var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacherStudent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-117"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.36,
    y: 348.99,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,375a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1.25-.25h0v3.27c0,1.09,0,2.18,0,3.25V375l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26s-.07,0-.22,0h-.7l-2.71,0-10.18.07-34.84.11h-.24V375q0-3.11,0-6.33v-6.52h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5,0,.26,0,.47,0,.64S409.45,375,409.44,375Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.23,
    y: 302.46,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.31,328.89a1.17,1.17,0,0,1,0-.23V328c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.24.24-.25h0v12.85l-.25-.24,34.68.11,10.23.07,2.77,0h.72l.26,0-.23,0h-.69l-2.72,0L55.49,329l-34.84.11h-.24V316h0l.25-.25,48.65.1h.15V316c0,4.06-.07,7.29-.09,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.64A1.39,1.39,0,0,1,69.31,328.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.55,51.22s0-.09,0-.24,0-.39,0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.08-9.44l.15.15-48.65.1.25-.25h0v6.52q0,3.22,0,6.33L279.9,51l34.67.11,10.23.07,2.77,0h.73l.25,0h-.22l-.7,0-2.71,0-10.18.07-34.84.11h-.24v-.24c0-2.07,0-4.18,0-6.33V38.37h0l.25-.25,48.65.1h.15v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5V51A.85.85,0,0,1,328.55,51.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.15,38.35a1.41,1.41,0,0,1,0-.25c0-.18,0-.41,0-.68,0-.63,0-1.49,0-2.58,0-2.26-.06-5.44-.1-9.36l.18.17-29.23.07.24-.24h0v6.61c0,2.15,0,4.24,0,6.24l-.23-.24,20.91.11,6.09.07,1.64,0,.59,0a3.28,3.28,0,0,1-.53,0l-1.6,0-6,.06-21.07.11h-.24v-.23c0-2,0-4.09,0-6.24V25.5h0c-.06.05.47-.47.25-.25l29.23.07h.18v.18c0,4-.08,7.18-.1,9.47,0,1.07,0,1.92,0,2.54S335.16,38.36,335.15,38.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.6,
    y: 251.97,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.68,278.4s0-.09,0-.24l0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.42-.09-9.44l.15.15-48.65.09.25-.24h0v6.52c0,2.15,0,4.26,0,6.33l-.24-.24,34.67.11,10.24.06,2.76,0h.73l.25,0h-.22l-.7,0-2.71,0-10.18.07-34.84.11h-.24v-.24q0-3.11,0-6.33v-6.52h0l.25-.25,48.65.1h.16v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A.85.85,0,0,1,697.68,278.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.57,
    y: 353.53,
    width: 48.65,
    height: 12.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.65,380s0-.09,0-.24l0-.66c0-.6,0-1.45,0-2.53,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1.25-.25h0v3.27c0,1.09,0,2.17,0,3.25V380l-.24-.24,34.67.11,10.23.07,2.77,0h.72l.26,0h-.22l-.7,0L691,380l-10.18.07L646,380.2h-.24V380q0-3.1,0-6.33v-6.52h0l.25-.25,48.65.1h.15v.15c0,4.06-.06,7.29-.08,9.53,0,1.07,0,1.9,0,2.5,0,.26,0,.47,0,.63A.85.85,0,0,1,694.65,380Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.57,
    y: 43.12,
    width: 112.04,
    height: 116.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.99,
    y: 43.12,
    width: 112.04,
    height: 116.79,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.06,160H589V43.09H701.06Zm-112-.07H701V43.16H589Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 604.05,
    y: 58.82,
    width: 81.92,
    height: 85.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.05,144.78a13.88,13.88,0,0,1-2,2.35c-1.31,1.38-3.15,3.25-5.21,5.28s-4,3.84-5.35,5.12a13.18,13.18,0,0,1-2.37,2,12.6,12.6,0,0,1,2-2.34c1.31-1.38,3.15-3.26,5.22-5.29s4-3.85,5.36-5.14A13.14,13.14,0,0,1,604.05,144.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686,144.57a14.36,14.36,0,0,1,2.35,2c1.38,1.31,3.24,3.15,5.27,5.21s3.84,4,5.13,5.35a13.35,13.35,0,0,1,2,2.37,13,13,0,0,1-2.34-2c-1.38-1.31-3.25-3.15-5.29-5.22s-3.85-4-5.13-5.36A12.11,12.11,0,0,1,686,144.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,59.05a13.31,13.31,0,0,1,2-2.35c1.31-1.38,3.15-3.25,5.21-5.28s4-3.84,5.35-5.12a12.3,12.3,0,0,1,2.37-2,13,13,0,0,1-2,2.34c-1.31,1.38-3.15,3.25-5.22,5.29s-4,3.84-5.36,5.13A12.61,12.61,0,0,1,685.74,59.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.82,59.26a13.75,13.75,0,0,1-2.35-2c-1.38-1.31-3.25-3.15-5.28-5.21s-3.84-4-5.12-5.35a13.35,13.35,0,0,1-2-2.37,13,13,0,0,1,2.34,2c1.38,1.31,3.25,3.15,5.29,5.22s3.85,4,5.13,5.36A12.61,12.61,0,0,1,603.82,59.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.74,144.21s0-.14,0-.41,0-.68,0-1.19c0-1.07,0-2.61,0-4.61,0-4.05,0-9.93-.08-17.41,0-15-.1-36.26-.16-61.77l.31.32-81.68,0h0l.36-.36c0,31.34,0,60.67,0,85.39l-.31-.31,59.15.16,16.61.08,4.4,0,1.14,0h.39a1.27,1.27,0,0,1-.36,0l-1.1,0-4.34,0-16.54.08-59.35.16h-.31v-.32c0-24.72,0-54.05-.06-85.39v-.36h.38l81.68,0h.32v.31c-.07,25.6-.12,47-.16,62,0,7.44-.07,13.3-.09,17.33,0,2,0,3.49,0,4.55,0,.49,0,.87,0,1.16A2.37,2.37,0,0,1,685.74,144.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.34,
    y: 87.85,
    width: 27.33,
    height: 27.33,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 50.85,
    width: 122.97,
    height: 178.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.54,
    y: 50.85,
    width: 122.97,
    height: 178.23,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.82,
    y: 70.15,
    width: 92.41,
    height: 139.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23,209.78s0-.24,0-.68,0-1.12,0-2c0-1.76,0-4.33,0-7.66,0-6.7,0-16.45-.08-28.77,0-24.62-.09-59.48-.15-100.54l.31.31-92.4,0h0l.33-.34c0,52.67,0,101.24-.07,139.63l-.26-.27,67.26.14,18.58.07,4.88,0,1.69,0-1.63,0-4.83,0-18.52.06L61.82,210h-.27v-.26c0-38.39,0-87-.07-139.63v-.33h.35l92.4,0h.3v.3c-.06,41.14-.11,76.08-.15,100.75,0,12.28-.06,22-.08,28.69,0,3.31,0,5.86,0,7.6,0,.84,0,1.49,0,1.94S154.23,209.78,154.23,209.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.85,50.85A21.7,21.7,0,0,1,167.66,54c-1.43,1.91-3.46,4.51-5.77,7.32s-4.48,5.3-6.08,7.07a21.87,21.87,0,0,1-2.7,2.76,22.08,22.08,0,0,1,2.34-3.07l5.92-7.18,5.92-7.19A23.35,23.35,0,0,1,169.85,50.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,209.33a114.68,114.68,0,0,0,16.12,20.16",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.82,229.49a18.27,18.27,0,0,1-2.81-2.56,85.92,85.92,0,0,1-6.08-6.86,87.9,87.9,0,0,1-5.36-7.44,18.82,18.82,0,0,1-1.87-3.3,25.71,25.71,0,0,1,2.27,3c1.35,1.9,3.26,4.5,5.48,7.28s4.34,5.21,5.9,7A25.24,25.24,0,0,1,170.82,229.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.52,228.94l16.11-19.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.63,209.07c.14.11-3.35,4.66-7.79,10.14s-8.17,9.85-8.32,9.73,3.35-4.66,7.8-10.15S62.49,209,62.63,209.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.54,50.85c.14-.12,3.65,4.07,7.82,9.34S61.8,69.84,61.65,70,58,65.89,53.83,60.61,46.4,51,46.54,50.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.49,
    y: 98.5,
    width: 30.94,
    height: 87.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.33,476.35c0,3.27-13.12,5.92-29.31,5.92s-29.31-2.65-29.31-5.92,13.13-5.93,29.31-5.93S500.33,473.07,500.33,476.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.6,57.91a2.07,2.07,0,0,1,0-.23l0-.66c0-.61,0-1.45,0-2.54,0-2.22,0-5.41-.08-9.44l.15.15-48.65.1.25-.25h0v6.52q0,3.22,0,6.33l-.24-.24,34.67.11,10.23.07,2.77,0,.73,0h.25s-.07,0-.22,0h-.7L507,58,496.79,58,462,58.15h-.24v-.24q0-3.1,0-6.33V45.06h0l.25-.25,48.65.1h.15V45c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5v.64C510.61,57.85,510.61,57.92,510.6,57.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.43,174.36a1,1,0,0,1,0-.23v-.66c0-.61,0-1.45,0-2.54,0-2.22-.05-5.41-.08-9.44l.15.15-48.65.1c.11-.11-.25.25.24-.25h0v12.85l-.24-.24,34.67.11,10.23.07,2.77,0,.72,0h.26l-.23,0h-.69l-2.72,0-10.17.07-34.84.11h-.25v-13.1h0l.25-.25,48.65.1h.15v.15c0,4.07-.06,7.29-.08,9.53,0,1.07,0,1.91,0,2.5l0,.64A1.23,1.23,0,0,1,245.43,174.36Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.66,434.78c0-.14,157.76-.26,352.32-.26s352.36.12,352.36.26S568.61,435,374,435,21.66,434.92,21.66,434.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-117"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "551.66 332.48 221.88 332.48 221.88 67.97 551.66 69.23 551.66 332.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.73,
    y: 80.23,
    width: 304.07,
    height: 239.38,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.68,312.41c38.67.69,75.33-20.38,85-29.28s15.5-23.11,10.64-35.08c-3.69-9.08-12.54-15-21.38-19.44s-18.35-8.13-25.44-15c-4-3.89-7.28-9.47-5.74-14.86,2.19-7.71,11.9-9.93,19.1-13.71,12.56-6.59,19.56-21.32,18.65-35.23s-8.82-26.71-19.57-35.69-24.14-14.45-37.81-18a165.92,165.92,0,0,0-106.6,8.27c-17.32,7.49-33.78,18.42-43.95,34.14-10.58,16.34-13.46,36.51-12,55.73,1.95,26.06,11.69,51.75,29.25,71.21,26.89,29.79,69.2,48.74,109.89,46.9",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383,105.13a6.72,6.72,0,0,1-4.75,1c0-.11,1.09-.15,2.39-.44S382.91,105,383,105.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.62,103.4a2.35,2.35,0,0,1-.57.25c-.38.14-.93.32-1.64.51a26.79,26.79,0,0,1-5.86.88.17.17,0,0,1-.19-.17.22.22,0,0,1,0-.08c.39-.94.82-2,1.25-3,1.23-2.92,2.36-5.56,3.2-7.47l1-2.24a4.82,4.82,0,0,1,.42-.81,4.7,4.7,0,0,1-.28.86l-.9,2.3c-.77,1.93-1.86,4.58-3.09,7.51-.44,1-.87,2-1.26,3l-.18-.25a30.84,30.84,0,0,0,5.82-.74C350.78,103.62,351.6,103.36,351.62,103.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.89,90.9c0,.11-2.23.11-5,.3s-4.93.47-4.95.36a5,5,0,0,1,1.42-.34c.89-.15,2.13-.3,3.51-.4s2.62-.1,3.52-.07A5.11,5.11,0,0,1,356.89,90.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4,98.13a8.18,8.18,0,0,1-2.8.83,8,8,0,0,1-2.92.13,19.17,19.17,0,0,1,2.86-.5A17.69,17.69,0,0,1,351.4,98.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.47,104.57a8.89,8.89,0,0,1-1.8.54,25.6,25.6,0,0,1-4.66.6.17.17,0,0,1-.19-.17.18.18,0,0,1,.08-.16,10.84,10.84,0,0,0,3.4-3.89,4.35,4.35,0,0,0,.49-1.3,1.13,1.13,0,0,0-.25-1,1.1,1.1,0,0,0-.88-.22,2,2,0,0,0-.7.26,4,4,0,0,1-.59.33,1.77,1.77,0,0,1,.51-.46,2.13,2.13,0,0,1,.74-.34,1.29,1.29,0,0,1,1.09.23,1.37,1.37,0,0,1,.39,1.29,4.74,4.74,0,0,1-.49,1.41,10.69,10.69,0,0,1-1.95,2.75,10.2,10.2,0,0,1-1.55,1.29l-.11-.33a32.15,32.15,0,0,0,4.63-.47A15.14,15.14,0,0,1,360.47,104.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.66,98.56a6.93,6.93,0,0,1-2.87.69,7.09,7.09,0,0,1-3-.17c0-.11,1.32-.06,2.91-.21S367.63,98.46,367.66,98.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,100.67a.94.94,0,0,1,.21.23,0,0,0,0,1,0,.06h0c-.46.12-1.53.33-3,.59l-2.47.42-.69.12a1,1,0,0,1-.42,0,.46.46,0,0,1-.37-.42,2.11,2.11,0,0,1,.06-.41l.07-.36.15-.75c.47-2.38.91-4.53,1.26-6.09a16,16,0,0,1,.63-2.5,18.57,18.57,0,0,1-.37,2.55c-.28,1.57-.68,3.73-1.15,6.11,0,.26-.1.5-.15.75l-.07.37a1.6,1.6,0,0,0-.05.31c0,.07,0,.06.07.08a.73.73,0,0,0,.29,0l.69-.11,2.47-.37c1.48-.21,2.57-.35,3-.38l0,.07C377,100.77,377,100.68,377,100.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.63,97.17a6.72,6.72,0,0,1-2.62.51,6.94,6.94,0,0,1-2.66-.21A17.33,17.33,0,0,1,373,97.3,16.29,16.29,0,0,1,375.63,97.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.9,91.27a19.12,19.12,0,0,1-3.79.94,21.21,21.21,0,0,1-3.86.57,19.12,19.12,0,0,1,3.79-.94A21.21,21.21,0,0,1,377.9,91.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.7,106a6.84,6.84,0,0,1-.23-1.68,33.79,33.79,0,0,1,0-4.08c0-.58.08-1.13.13-1.65l.35.07a6.28,6.28,0,0,1-1.54,2.57,2.61,2.61,0,0,1-.94.71s.31-.31.77-.86a7.17,7.17,0,0,0,1.37-2.52.17.17,0,0,1,.22-.12.17.17,0,0,1,.13.19c0,.51-.08,1.06-.11,1.63-.09,1.58-.1,3-.09,4.05A9,9,0,0,1,380.7,106Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,97.57a15.41,15.41,0,0,1-6.14.66,79.94,79.94,0,0,1,6.14-.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.41,101.36a12.5,12.5,0,0,1-.81-3,13.31,13.31,0,0,1-.43-3.11,12.77,12.77,0,0,1,.8,3A13.68,13.68,0,0,1,387.41,101.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,101.39a7.28,7.28,0,0,1-1.78.45,22.17,22.17,0,0,1-4.6.3.18.18,0,0,1-.18-.19h0c.05-.61.11-1.24.16-1.9.2-2.29.4-4.36.57-5.86a15.75,15.75,0,0,1,.34-2.42,14.15,14.15,0,0,1-.08,2.44c-.09,1.51-.25,3.58-.45,5.87-.06.66-.12,1.3-.17,1.9l-.18-.2a27.94,27.94,0,0,0,4.55-.16C398.43,101.47,399.1,101.35,399.12,101.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,91.63a13.78,13.78,0,0,1-3.16.35,14,14,0,0,1-3.18,0,13.78,13.78,0,0,1,3.16-.35A14,14,0,0,1,399.53,91.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,97a7,7,0,0,1-2.17.52,6.59,6.59,0,0,1-2.24.14,7,7,0,0,1,2.18-.52A6.53,6.53,0,0,1,397.17,97Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1,97.14c-.09-.06,0-.3.1-.55l.08-.12,0,0a.17.17,0,0,1,.24,0,.15.15,0,0,1,.06.09c.07.21.08.38,0,.42s-.22-.08-.33-.27h.32a.75.75,0,0,1-.06.13C409.38,97,409.19,97.19,409.1,97.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.44,105.8a25.47,25.47,0,0,0,1.4-2.8,27,27,0,0,0,.69-3,6.73,6.73,0,0,1-2.09,5.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.31,104.11s-.05.12-.19.3a.08.08,0,0,1-.11,0,.06.06,0,0,1,0-.09v0a24.06,24.06,0,0,1,2.38-2.93,16.25,16.25,0,0,1,3.07-2.76,36.76,36.76,0,0,1-2.8,3c-1.14,1.22-2.09,2.32-2.54,2.77l-.11-.1C399.19,104.16,399.3,104.09,399.31,104.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.45,104.4a21.82,21.82,0,0,1-1.55-3.77,22,22,0,0,1-1.18-3.91,22.12,22.12,0,0,1,1.54,3.78A22.69,22.69,0,0,1,403.45,104.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.39,127.82a2.17,2.17,0,0,1-.29-.61,12.54,12.54,0,0,1-.5-1.77,13.1,13.1,0,0,1,3.16-11.37,10.69,10.69,0,0,1,1.35-1.26,2.09,2.09,0,0,1,.57-.38s-.73.64-1.71,1.81a13.82,13.82,0,0,0-3.11,11.15C293.1,126.9,293.46,127.8,293.39,127.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.39,125.71a5.08,5.08,0,0,1-.33-1.39,29.14,29.14,0,0,1-.33-3.43,29.74,29.74,0,0,1,.09-3.45,4.9,4.9,0,0,1,.24-1.41c.11,0-.05,2.17.05,4.84S299.5,125.69,299.39,125.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.94,125.5a.87.87,0,0,1-.41.3,1.9,1.9,0,0,1-1.42,0,2.53,2.53,0,0,1-.85-.58,2.74,2.74,0,0,1-.6-1,6.38,6.38,0,0,1-.11-2.77.16.16,0,0,1,.19-.15.18.18,0,0,1,.16.19,7,7,0,0,1-1.51,3.57,2.58,2.58,0,0,1-1.95,1.08,1.21,1.21,0,0,1-1-.59,2,2,0,0,1-.22-1,3.24,3.24,0,0,1,1.95-2.74,3.11,3.11,0,0,1,2.29-.05,1.69,1.69,0,0,1,.72.42s-.26-.14-.77-.28a3.12,3.12,0,0,0-2.13.15,3,3,0,0,0-1.71,2.52,1.56,1.56,0,0,0,.18.83.83.83,0,0,0,.69.41,2.25,2.25,0,0,0,1.63-1,6.76,6.76,0,0,0,1.46-3.37l.35,0a6.45,6.45,0,0,0,0,2.64,2.32,2.32,0,0,0,1.25,1.51,1.84,1.84,0,0,0,1.3.14C307.79,125.59,307.92,125.47,307.94,125.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,127a7.76,7.76,0,0,1-.34-1.71c-.14-1.07-.29-2.55-.36-4.2s-.05-3.13,0-4.21a7.53,7.53,0,0,1,.19-1.74,8.22,8.22,0,0,1,.08,1.75c0,1.07,0,2.55.09,4.19s.18,3.11.26,4.18A8.23,8.23,0,0,1,310,127Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.38,123.37c0,.1-.55.22-1.23.26s-1.26,0-1.27-.11.55-.22,1.24-.26S314.38,123.26,314.38,123.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.73,119a3.64,3.64,0,0,1-1.52.57,3.57,3.57,0,0,1-1.61.21c0-.11.66-.36,1.52-.57A3.57,3.57,0,0,1,321.73,119Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.27,125.85a4.53,4.53,0,0,0,2.15.41,3.68,3.68,0,0,0,2.14-.91,2.67,2.67,0,0,0,.75-1.11,2,2,0,0,0,0-1.39,1,1,0,0,0-.66-.6,1.57,1.57,0,0,0-.91,0,4.38,4.38,0,0,0-1.48,1h0a.16.16,0,0,1-.23,0,.16.16,0,0,1,0-.13c.2-1.11.38-2,.52-2.68a4.34,4.34,0,0,1,.26-1,4.06,4.06,0,0,1-.08,1c-.08.65-.21,1.58-.38,2.69l-.27-.14a4.17,4.17,0,0,1,1.59-1.12,2,2,0,0,1,1.13,0,1.48,1.48,0,0,1,.9.8,2.64,2.64,0,0,1-.85,2.92,3.83,3.83,0,0,1-2.35.92,3.54,3.54,0,0,1-1.66-.33A1.31,1.31,0,0,1,316.27,125.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,127.92s.63-.61,1.37-1.78a8.47,8.47,0,0,0-.63-10c-.88-1.07-1.62-1.54-1.58-1.6a1.81,1.81,0,0,1,.54.3,7.64,7.64,0,0,1,1.24,1.13,8.32,8.32,0,0,1,.65,10.34,6.8,6.8,0,0,1-1.1,1.26C322.41,127.82,322.23,127.94,322.21,127.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,118.2a3.5,3.5,0,0,1-1.2.47,11.81,11.81,0,0,1-3.27.39.19.19,0,0,1-.18-.19.19.19,0,0,1,0-.07c.23-.51.47-1.08.68-1.68a20.69,20.69,0,0,0,.69-2.35,1,1,0,0,0-.15-.88,1,1,0,0,0-.74-.32,2.28,2.28,0,0,0-1.21.4c-.27.17-.42.27-.44.24s.11-.15.36-.36a2.13,2.13,0,0,1,1.3-.55,1.34,1.34,0,0,1,1,.37,1.32,1.32,0,0,1,.27,1.16,16.79,16.79,0,0,1-.68,2.42,18.14,18.14,0,0,1-.71,1.7l-.16-.25A19,19,0,0,0,331.54,118.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.68,131c0,.11-9.09.19-20.29.19s-20.29-.08-20.29-.19,9.08-.19,20.29-.19S329.68,130.91,329.68,131Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,133.65a4.83,4.83,0,0,1-2.33.88,5.07,5.07,0,0,1-2.5,0,22.54,22.54,0,0,1,2.43-.36C303.93,133.93,305,133.55,305,133.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.87,141.19s.11.24.42.54a2.31,2.31,0,0,0,1.69.52,4.67,4.67,0,0,0,2.4-1.21,13.58,13.58,0,0,0,1.23-1.08,3,3,0,0,0,.84-1.43,1.77,1.77,0,0,0-1.55-2.05,1.82,1.82,0,0,0-1.84,1.31.16.16,0,0,1-.17.11.15.15,0,0,1-.11-.14c0-.92,0-1.67,0-2.19a2.75,2.75,0,0,1,.05-.81,3.74,3.74,0,0,1,.1.8c0,.52.1,1.27.15,2.19l-.28,0a2.07,2.07,0,0,1,4,.88,3.31,3.31,0,0,1-.95,1.62,12.57,12.57,0,0,1-1.28,1.09,4.7,4.7,0,0,1-2.6,1.2,2.3,2.3,0,0,1-1.8-.68A1.08,1.08,0,0,1,297.87,141.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.39,142.87a30.9,30.9,0,0,1,.31-4.94,30.76,30.76,0,0,1,.69-4.9,33.25,33.25,0,0,1-.32,4.94A32.74,32.74,0,0,1,309.39,142.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,138.45a2.33,2.33,0,0,1-.46.51,4.18,4.18,0,0,1-1.62,1,2.1,2.1,0,0,1-1.37-.07,2.58,2.58,0,0,1-1.18-1.07,5.68,5.68,0,0,1-.42-3.54l.35.1a5.82,5.82,0,0,0-.37,1.41,6.59,6.59,0,0,1-.27,1.06,2.36,2.36,0,0,1-.61.93,1.76,1.76,0,0,1-1,.49,1.22,1.22,0,0,1-1-.38,1.84,1.84,0,0,1-.27-1.84,6.58,6.58,0,0,1,.74-1.4,2.56,2.56,0,0,1,1-.87,1.53,1.53,0,0,1,1-.06c.55.17.65.54.63.53a1.33,1.33,0,0,0-.67-.39,1.36,1.36,0,0,0-.88.12,2.29,2.29,0,0,0-.86.82,6.78,6.78,0,0,0-.66,1.35,1.5,1.5,0,0,0,.23,1.5.82.82,0,0,0,.71.26,1.37,1.37,0,0,0,.77-.4,3,3,0,0,0,.77-1.79,5.56,5.56,0,0,1,.41-1.5.17.17,0,0,1,.24-.09.18.18,0,0,1,.11.19,5.43,5.43,0,0,0,.34,3.33,2.29,2.29,0,0,0,1,1,1.83,1.83,0,0,0,1.19.1,4.6,4.6,0,0,0,1.59-.88A2.78,2.78,0,0,1,321,138.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.32,141.78c-.11,0,.4-2.09.71-4.67s.3-4.69.41-4.69a15.67,15.67,0,0,1,0,4.74A16.18,16.18,0,0,1,322.32,141.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,202.35s0,0-.08.07a1.73,1.73,0,0,1-.27.16,2.65,2.65,0,0,1-1.17.25,3.66,3.66,0,0,1-1.81-.55,4.18,4.18,0,0,1-1.65-1.89,7.61,7.61,0,0,1-.59-3c0-1.09.12-2.25.21-3.45a10,10,0,0,0-.24-3.71,4.31,4.31,0,0,0-2.45-2.86l-.3-.09h0a.19.19,0,0,1-.12-.24.18.18,0,0,1,.15-.13,2.71,2.71,0,0,0,1.63-.93,4,4,0,0,0,.88-1.66,9.35,9.35,0,0,0,0-3.65,17.45,17.45,0,0,1-.21-3.41,7,7,0,0,1,.73-2.89,4.38,4.38,0,0,1,3.45-2.38,3,3,0,0,1,1.17.15,1.13,1.13,0,0,1,.36.18,3.64,3.64,0,0,0-1.51-.18,4.22,4.22,0,0,0-3.23,2.35,6.74,6.74,0,0,0-.66,2.79,16.31,16.31,0,0,0,.25,3.34,9.91,9.91,0,0,1,0,3.8,4.42,4.42,0,0,1-1,1.81,3,3,0,0,1-1.86,1.05l0-.37.33.1a4.66,4.66,0,0,1,2.68,3.12A10.1,10.1,0,0,1,261,194c-.11,1.21-.26,2.35-.25,3.42a7.38,7.38,0,0,0,.53,2.87,3.9,3.9,0,0,0,1.51,1.82,3.66,3.66,0,0,0,1.71.58A3.23,3.23,0,0,0,266,202.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.92,192.42a41,41,0,0,0,3.52-4.9,43,43,0,0,0,2.41-5.54,5.83,5.83,0,0,1-.37,1.75,19.74,19.74,0,0,1-4.25,7.48A6.15,6.15,0,0,1,265.92,192.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.45,191a6.55,6.55,0,0,1-1.2-1.17c-.69-.77-1.61-1.87-2.55-3.14s-1.7-2.48-2.23-3.38a6,6,0,0,1-.75-1.5,10.53,10.53,0,0,1,1,1.36c.58.85,1.38,2,2.31,3.3s1.81,2.38,2.45,3.19A8.72,8.72,0,0,1,273.45,191Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,194.05s.05.07.08.23a1.46,1.46,0,0,1-.06.72,2.08,2.08,0,0,1-.64.95,2,2,0,0,1-1.45.48,2.39,2.39,0,0,1-1.62-.88,2.86,2.86,0,0,1-.52-.92,3.36,3.36,0,0,1-.13-1.09c0-.73.13-1.51-.37-2a.8.8,0,0,0-.86-.3,1.27,1.27,0,0,0-.62.83,13.7,13.7,0,0,0-.67,4.86.18.18,0,0,1-.16.18.17.17,0,0,1-.18-.14c-.4-2.05-.73-3.78-.95-5-.09-.56-.17-1-.24-1.43a2,2,0,0,1,0-.51,2.25,2.25,0,0,1,.15.49c.09.39.21.86.34,1.41.27,1.22.65,2.94,1.07,5l-.34,0a13.81,13.81,0,0,1,.66-5,1.63,1.63,0,0,1,.84-1.06,1.15,1.15,0,0,1,1.27.41,1.81,1.81,0,0,1,.46,1.16,10.34,10.34,0,0,1,0,1.12,2.38,2.38,0,0,0,1.95,2.63,1.81,1.81,0,0,0,1.28-.38,1.93,1.93,0,0,0,.64-.84A2.06,2.06,0,0,0,283.78,194.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.56,186.81a7.57,7.57,0,0,1-3,.73,7.44,7.44,0,0,1-3.09-.18c0-.11,1.38,0,3.06-.19S286.53,186.7,286.56,186.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,191.05a12.85,12.85,0,0,1-1.45-3.85,12.71,12.71,0,0,1-.53-4.08c.11,0,.35,1.81.9,4S285.4,191,285.3,191.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.39,195.32s0,.11.15.28a1.27,1.27,0,0,0,.71.54,1.93,1.93,0,0,0,1.39-.06,2.48,2.48,0,0,0,1.19-1.4,8.61,8.61,0,0,0,.45-2.31,22,22,0,0,0,.06-2.72,21.17,21.17,0,0,0-1.2-6.12c-.17-.45-.35-.9-.53-1.31a.19.19,0,0,1,.34-.17,9.31,9.31,0,0,1,1.23,2.8,3.36,3.36,0,0,1-.57,2.79,2.18,2.18,0,0,1-2.42.76,3.26,3.26,0,0,1-1.74-1.4,5.71,5.71,0,0,1-.62-3.09c0-.37,0-.66.06-.85a.9.9,0,0,1,.05-.29,8.4,8.4,0,0,1,0,1.14,5.88,5.88,0,0,0,.7,3,3,3,0,0,0,1.61,1.25,1.85,1.85,0,0,0,2.06-.67,3.06,3.06,0,0,0,.49-2.52,9.26,9.26,0,0,0-1.21-2.68l.34-.17c.18.42.36.87.53,1.34a20.15,20.15,0,0,1,1.1,9,8.65,8.65,0,0,1-.51,2.38,2.67,2.67,0,0,1-1.36,1.5,2.11,2.11,0,0,1-1.53,0,1.36,1.36,0,0,1-.72-.64A.58.58,0,0,1,291.39,195.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,193.7s.14.22,0,.61a1.34,1.34,0,0,1-.53.53,1.29,1.29,0,0,1-1,.09,2.54,2.54,0,0,1-1.55-2c-.13-.48-.19-1-.32-1.49a3,3,0,0,0-.7-1.37l.29,0a11.2,11.2,0,0,0-1,2.51,11.44,11.44,0,0,0-.3,3.67.17.17,0,0,1-.16.19.18.18,0,0,1-.19-.14c-.36-2-.67-3.71-.87-4.93a11.75,11.75,0,0,1-.25-1.93,12.53,12.53,0,0,1,.47,1.89c.26,1.21.61,2.91,1,4.9l-.35.05a11.32,11.32,0,0,1,.29-3.79,11.07,11.07,0,0,1,1-2.6.17.17,0,0,1,.24-.07l0,0a3.13,3.13,0,0,1,.78,1.55c.13.53.19,1,.29,1.5a2.34,2.34,0,0,0,1.33,1.85,1.15,1.15,0,0,0,1.34-.46A1.24,1.24,0,0,0,305,193.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.27,205.22a3.47,3.47,0,0,0,1.5.06,4.49,4.49,0,0,0,3-2.67,7.31,7.31,0,0,0,.46-2.81c0-1-.15-2.16-.24-3.35a10.31,10.31,0,0,1,.24-3.76,5.92,5.92,0,0,1,.84-1.85,4,4,0,0,1,1.61-1.36h0a.18.18,0,0,1,.25.09.19.19,0,0,1-.05.21,2.27,2.27,0,0,1-.79.52,3,3,0,0,1-2.2-.08,3.71,3.71,0,0,1-1.68-1.32,6.91,6.91,0,0,1-1-3.8c0-2.49.08-4.71.11-6.58a5.25,5.25,0,0,0-.34-2.43,1.89,1.89,0,0,0-1.36-1.1,1.5,1.5,0,0,0-1.12.16c-.22.16-.29.29-.31.27a.92.92,0,0,1,.27-.33,1.48,1.48,0,0,1,1.19-.24,2,2,0,0,1,1.52,1.15,5.44,5.44,0,0,1,.42,2.52c0,1.87-.05,4.11,0,6.57a6.71,6.71,0,0,0,1,3.6,3.29,3.29,0,0,0,1.51,1.18,2.65,2.65,0,0,0,1.92.08,1.89,1.89,0,0,0,.66-.43l.22.3a4.42,4.42,0,0,0-2.26,3,10.25,10.25,0,0,0-.25,3.64c.08,1.17.22,2.3.21,3.37a7.47,7.47,0,0,1-.53,2.91,4.58,4.58,0,0,1-3.16,2.71,2.59,2.59,0,0,1-1.16,0A1.68,1.68,0,0,1,305.27,205.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.09,255.92c-.09-.07,1.36-2,2.91-4.48s2.65-4.63,2.75-4.58a5.59,5.59,0,0,1-.59,1.46,36.8,36.8,0,0,1-4,6.43A6.1,6.1,0,0,1,423.09,255.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.16,255.28A80.92,80.92,0,0,1,421.8,248a41.46,41.46,0,0,1,4.3,3.52A42.18,42.18,0,0,1,430.16,255.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07,250.45a5.4,5.4,0,0,1-2.55,1,5.54,5.54,0,0,1-2.73,0c0-.11,1.21-.08,2.66-.34S440,250.34,440.07,250.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.37,254.05a9.73,9.73,0,0,1-.87-6.62c.12,0,0,1.51.22,3.34S437.48,254,437.37,254.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.62,244.31s.22.18.66.41a3.21,3.21,0,0,0,2,.38,2.26,2.26,0,0,0,1.23-.6,2.36,2.36,0,0,0,.71-1.39,1.68,1.68,0,0,0-.54-1.53,1.85,1.85,0,0,0-1.72-.32,1.31,1.31,0,0,0-.72.53l-.13-.28a1.51,1.51,0,0,0,1.4-2.18,2,2,0,0,0-2.25-1,2.71,2.71,0,0,0-1.46,1c-.26.35-.35.58-.38.57a1.63,1.63,0,0,1,.26-.65,2.72,2.72,0,0,1,1.51-1.2,2.3,2.3,0,0,1,2.62,1.06,1.86,1.86,0,0,1-1.75,2.71.19.19,0,0,1-.17-.21l0-.08a1.69,1.69,0,0,1,.92-.69,2.21,2.21,0,0,1,2.08.4,2,2,0,0,1,.64,1.86,2.67,2.67,0,0,1-.83,1.57,2.46,2.46,0,0,1-1.41.63,3.19,3.19,0,0,1-2.11-.51A1.7,1.7,0,0,1,442.62,244.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.41,243s0,.08-.05.21a2.64,2.64,0,0,1-.32.54,2.68,2.68,0,0,1-2,1,2.77,2.77,0,0,1-2.63-2,5.67,5.67,0,0,0-.57-1.8,1.17,1.17,0,0,0-.72-.48.81.81,0,0,0-.73.4,9.39,9.39,0,0,0-1.22,4.08.19.19,0,0,1-.19.16.19.19,0,0,1-.15-.12,19.4,19.4,0,0,1-.79-4.36,11.72,11.72,0,0,1,0-1.26,1.38,1.38,0,0,1,0-.44,15,15,0,0,1,.19,1.68,22.77,22.77,0,0,0,.92,4.27l-.34,0a9.59,9.59,0,0,1,1.26-4.27,1.2,1.2,0,0,1,1.08-.55,1.49,1.49,0,0,1,1,.63,5.81,5.81,0,0,1,.61,1.93,2.49,2.49,0,0,0,2.3,1.82,2.63,2.63,0,0,0,1.92-.84C460.28,243.27,460.38,243,460.41,243Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.38,240.13a5.08,5.08,0,0,1-2.48.94,5.16,5.16,0,0,1-2.64-.07c0-.11,1.18-.06,2.58-.31S465.33,240,465.38,240.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.59,240.24s-.09.15-.31.38a5.39,5.39,0,0,1-1,.87,2.68,2.68,0,0,1-2,.38,1.74,1.74,0,0,1-1.06-.7,2.77,2.77,0,0,1-.42-1.27,37.26,37.26,0,0,1-.05-4.42,7.43,7.43,0,0,1,.19-1.82,10.52,10.52,0,0,1,.07,1.82c0,1.12,0,2.69.17,4.38a2.42,2.42,0,0,0,.34,1.1,1.39,1.39,0,0,0,.84.57,2.43,2.43,0,0,0,1.79-.27,7.7,7.7,0,0,0,1.08-.75C471.43,240.32,471.57,240.22,471.59,240.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.17,245.54a5.68,5.68,0,0,1-.34-1.5,35,35,0,0,1-.35-3.67,32.88,32.88,0,0,1,0-3.69,5.46,5.46,0,0,1,.22-1.52c.11,0,0,2.33.11,5.19S472.28,245.52,472.17,245.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.54,250.45c0,.1-11.75.18-26.23.18s-26.22-.08-26.22-.18,11.74-.19,26.22-.19S495.54,250.34,495.54,250.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.49,260.41s0,.39-.5.7a1.43,1.43,0,0,1-1.05.13,1.84,1.84,0,0,1-1.08-.88,3.55,3.55,0,0,1-.45-1.62,10.16,10.16,0,0,0-.15-1.82,1.32,1.32,0,0,0-.44-.74.65.65,0,0,0-.77.06,3.7,3.7,0,0,0-.67.78c-.21.3-.42.61-.61.92a15.34,15.34,0,0,0-1.67,3.84.17.17,0,0,1-.21.12.16.16,0,0,1-.13-.13,38.09,38.09,0,0,0-1.14-4.69,18.7,18.7,0,0,1-.56-1.8s.1.14.24.44.31.73.52,1.29a30.23,30.23,0,0,1,1.28,4.69h-.34a15.12,15.12,0,0,1,1.68-3.94c.2-.33.41-.65.63-.95a4,4,0,0,1,.76-.86,1,1,0,0,1,1.19-.06,1.66,1.66,0,0,1,.58.95,10.71,10.71,0,0,1,.12,1.89,3.32,3.32,0,0,0,.37,1.5,1.63,1.63,0,0,0,.91.82,1.35,1.35,0,0,0,.92-.06A1.23,1.23,0,0,0,449.49,260.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.49,256.4a11.08,11.08,0,0,1-2.45.84.18.18,0,0,1-.21-.11h0a2,2,0,0,1,.13-1.34,4.55,4.55,0,0,0,.43-1.35c0-.42-.16-.75-.45-.8a.68.68,0,0,0-.66.14c-.1.12-.09.25-.12.25s-.1-.12,0-.33a.79.79,0,0,1,.83-.32.77.77,0,0,1,.56.36,1.33,1.33,0,0,1,.19.71,4.13,4.13,0,0,1-.43,1.48,1.8,1.8,0,0,0-.14,1.09l-.22-.12A11.41,11.41,0,0,1,453.49,256.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.56,259.5a2.59,2.59,0,0,1-1.54.65,2.55,2.55,0,0,1-1.67-.08,7.33,7.33,0,0,1,1.6-.29A7.16,7.16,0,0,1,458.56,259.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,261.15a1.59,1.59,0,0,1-.46.21,9.18,9.18,0,0,1-1.35.36,12.33,12.33,0,0,1-4.72,0,.2.2,0,0,1-.15-.22.25.25,0,0,1,.08-.12c.39-.26.8-.53,1.18-.83a4.65,4.65,0,0,0,1.78-2.36,2.23,2.23,0,0,0-.46-2.23,2,2,0,0,0-1.46-.59,3.55,3.55,0,0,0-.6.14s.15-.2.58-.28a2,2,0,0,1,1.67.53,2.51,2.51,0,0,1,.61,2.52,4.87,4.87,0,0,1-1.89,2.57c-.4.31-.81.58-1.2.84l-.07-.34a13.29,13.29,0,0,0,4.61.13C467.28,261.32,468,261.1,468,261.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,259.61a.83.83,0,0,1-.12.21,2.22,2.22,0,0,1-.49.49,2.69,2.69,0,0,1-2.46.38,2.88,2.88,0,0,1-1.39-1.11,3.25,3.25,0,0,1-.45-2,3.2,3.2,0,0,0-.32-2,1.16,1.16,0,0,0-.79-.54.83.83,0,0,0-.8.45,4.8,4.8,0,0,0-.46,1.43c-.09.5-.16,1-.2,1.47a12.71,12.71,0,0,0,.06,2.71.17.17,0,0,1-.14.19.17.17,0,0,1-.18-.13c-.32-1.7-.57-3.11-.74-4.1a9.63,9.63,0,0,1-.21-1.56,9.73,9.73,0,0,1,.4,1.52c.22,1,.52,2.39.87,4.08l-.32.05a12.59,12.59,0,0,1-.11-2.78,13.53,13.53,0,0,1,.21-1.52,4.73,4.73,0,0,1,.5-1.56,1.23,1.23,0,0,1,1.16-.63,1.54,1.54,0,0,1,1,.71,2.15,2.15,0,0,1,.38,1.13,9.63,9.63,0,0,1,0,1.08,2.86,2.86,0,0,0,.37,1.8,2.66,2.66,0,0,0,1.22,1,2.61,2.61,0,0,0,2.28-.25A5.77,5.77,0,0,0,479,259.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.44,260.25a15.09,15.09,0,0,1-.66-3.28,15.32,15.32,0,0,1-.29-3.32,14.56,14.56,0,0,1,.67,3.27A14.28,14.28,0,0,1,481.44,260.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.78,255.73a8.61,8.61,0,0,1-3,1.36,8.43,8.43,0,0,1-3.24.52c0-.1,1.42-.36,3.13-.88S484.73,255.63,484.78,255.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.46,259.32a11.6,11.6,0,0,1-2,.56c-1.24.31-3,.72-4.95,1.16a.18.18,0,0,1-.22-.13.2.2,0,0,1,.05-.18,12,12,0,0,0,1.14-1.3,11.89,11.89,0,0,0,1.66-2.95,1.64,1.64,0,0,0,0-1.33,1.31,1.31,0,0,0-1-.57,2.78,2.78,0,0,0-1.73.49,4.2,4.2,0,0,1-.6.35s.16-.2.52-.47a2.83,2.83,0,0,1,1.83-.64,1.59,1.59,0,0,1,1.23.68,1.91,1.91,0,0,1,.1,1.59,11.45,11.45,0,0,1-1.69,3.08,13.94,13.94,0,0,1-1.18,1.34l-.17-.32c2-.43,3.73-.79,5-1A12.69,12.69,0,0,1,493.46,259.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.73,144.52a1.15,1.15,0,0,1-1,.23,2.16,2.16,0,0,1-1.09-.53,2.46,2.46,0,0,1-.8-1.38,5.91,5.91,0,0,1,0-1.93,17.63,17.63,0,0,0,.23-2.12,3,3,0,0,0-.64-2.11,6.89,6.89,0,0,1-.88-1,1,1,0,0,1-.13-.76,1,1,0,0,1,.48-.61,8,8,0,0,1,1.24-.5,2.07,2.07,0,0,0,.9-.7,4.46,4.46,0,0,0,.76-2.14c.14-1.47,0-2.93.6-4a2.64,2.64,0,0,1,2.25-1.5,1.44,1.44,0,0,1,.74.19c.14.09.21.16.2.17a2.07,2.07,0,0,0-.94-.22,2.54,2.54,0,0,0-2,1.47,5.12,5.12,0,0,0-.39,1.78c-.05.67,0,1.39-.1,2.17a4.74,4.74,0,0,1-.81,2.32,2.5,2.5,0,0,1-1.06.83,8.53,8.53,0,0,0-1.18.47.59.59,0,0,0-.23.86,6.82,6.82,0,0,0,.84.89,3.4,3.4,0,0,1,.71,2.36,16.53,16.53,0,0,1-.27,2.16,5.64,5.64,0,0,0,0,1.83,2.31,2.31,0,0,0,1.65,1.83A1.84,1.84,0,0,0,380.73,144.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.75,139.23c-.09-.08,1.16-1.63,2.27-3.8s1.65-4.09,1.76-4.06a11.84,11.84,0,0,1-1.42,4.23A12.05,12.05,0,0,1,383.75,139.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.63,138a25.8,25.8,0,0,1-3.65-2.55,25.86,25.86,0,0,1-3.43-2.85,25.8,25.8,0,0,1,3.65,2.55A26.69,26.69,0,0,1,389.63,138Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.29,142.33s-.3-.6-.8-1.6a26,26,0,0,0-2.38-3.84l.31,0a12.31,12.31,0,0,0-.74,2.36,11.85,11.85,0,0,0-.25,3,.18.18,0,0,1-.35,0c-.22-1.69-.4-3.13-.51-4.16a9.29,9.29,0,0,1-.12-1.63,8.22,8.22,0,0,1,.34,1.6c.17,1,.39,2.46.64,4.14l-.35,0a11.21,11.21,0,0,1,.23-3.06,11.84,11.84,0,0,1,.78-2.42.18.18,0,0,1,.24-.1.22.22,0,0,1,.07.06,20.75,20.75,0,0,1,2.29,4A7.1,7.1,0,0,1,395.29,142.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.38,146.92a2.19,2.19,0,0,0,1.06.34,2.33,2.33,0,0,0,1.24-.34,2.61,2.61,0,0,0,1.1-1.28,4.89,4.89,0,0,0,.29-2.07,21.67,21.67,0,0,0-.36-2.45,7.13,7.13,0,0,1-.06-2.81,3.31,3.31,0,0,1,1.85-2.39,2,2,0,0,1,.62-.15.18.18,0,0,1,.21.16.19.19,0,0,1-.07.17h0a1.35,1.35,0,0,1-1.57,0,2.1,2.1,0,0,1-.94-1.19,6.06,6.06,0,0,1,.19-2.71,7.79,7.79,0,0,0-.39-4.32,8.4,8.4,0,0,0-1.54-2.52c-.47-.52-.78-.76-.76-.79s.09,0,.24.16a4.54,4.54,0,0,1,.62.53,7.91,7.91,0,0,1,2.17,7,5.77,5.77,0,0,0-.17,2.54,1.71,1.71,0,0,0,.77,1,1,1,0,0,0,1.15,0l.13.33a2.55,2.55,0,0,0-.51.13,3,3,0,0,0-1.63,2.12,7.25,7.25,0,0,0,0,2.67,19.09,19.09,0,0,1,.33,2.5,5,5,0,0,1-.36,2.19,2.62,2.62,0,0,1-1.24,1.35,2.49,2.49,0,0,1-1.35.31,1.64,1.64,0,0,1-.83-.28C396.44,147,396.37,146.93,396.38,146.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.68,138.55a1.63,1.63,0,0,1-.52.1,10.79,10.79,0,0,1-1.44.07,6.41,6.41,0,0,1-2.14-.39,4.29,4.29,0,0,1-2.12-1.63,3,3,0,0,1-.33-2.65,3.61,3.61,0,0,1,1.3-1.75,2.71,2.71,0,0,1,1.37-.54,1.18,1.18,0,0,1,.53,0,3.89,3.89,0,0,0-1.74.72,3.52,3.52,0,0,0-1.13,1.65,2.7,2.7,0,0,0,.32,2.34,4.19,4.19,0,0,0,1.93,1.51,6.9,6.9,0,0,0,2,.44C410.92,138.54,411.68,138.48,411.68,138.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.75,139.08a4.27,4.27,0,0,1-.61-.39l-1.65-1.19-5.82-4.29a.16.16,0,0,1,0-.23.15.15,0,0,1,.14-.07,4.6,4.6,0,0,0,3.57-1.8,4.41,4.41,0,0,0,.83-4.3,2.9,2.9,0,0,0-1.08-1.43,2.12,2.12,0,0,0-1.67-.3,1.75,1.75,0,0,0-1.17,1.08,4.66,4.66,0,0,0-.26,1.66,57.26,57.26,0,0,0,.46,6c.22,1.7.46,3.08.64,4,.08.44.15.8.21,1.09a2.22,2.22,0,0,1,.05.39,1.49,1.49,0,0,1-.13-.37c-.07-.24-.16-.61-.27-1.08-.23-.94-.51-2.31-.77-4a50.86,50.86,0,0,1-.53-6.05,4.7,4.7,0,0,1,.27-1.79,2.09,2.09,0,0,1,1.41-1.3,2.43,2.43,0,0,1,2,.33,3.28,3.28,0,0,1,1.24,1.62,4.37,4.37,0,0,1,.16,2.5,5.35,5.35,0,0,1-1.07,2.16,4.87,4.87,0,0,1-3.86,1.9l.1-.3,5.74,4.41,1.59,1.25A3.51,3.51,0,0,1,421.75,139.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,217.83a4.42,4.42,0,0,1-1.26.75,14.75,14.75,0,0,1-3.34,1.11,15.19,15.19,0,0,1-3.5.31,4.77,4.77,0,0,1-1.45-.19,38.43,38.43,0,0,0,4.88-.49A35.78,35.78,0,0,0,354.37,217.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,225.81a75.33,75.33,0,0,1,6.89-8.23,39,39,0,0,1-3.3,4.24A38.85,38.85,0,0,1,345.62,225.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.65,224.53a31.71,31.71,0,0,1-4.89.73,33.35,33.35,0,0,1-4.92.36,31.17,31.17,0,0,1,4.88-.73A33.45,33.45,0,0,1,354.65,224.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,211.22a32.24,32.24,0,0,1,2.63-4.21,31.94,31.94,0,0,1,2.94-4,31.94,31.94,0,0,1-2.63,4.22A32.25,32.25,0,0,1,435,211.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.59,211.22a22.28,22.28,0,0,1-3.55-3.5c-1.85-2-3.7-3.29-3.61-3.39a4.8,4.8,0,0,1,1.24.78,18.25,18.25,0,0,1,2.65,2.35c.93,1,1.73,2,2.34,2.63A6,6,0,0,1,440.59,211.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08,137.55a1.36,1.36,0,0,0,1,.29,1.86,1.86,0,0,0,1.1-.55,2.44,2.44,0,0,0,.6-1.53,11.1,11.1,0,0,0-.13-2.09q-.14-1.15-.27-2.43c-.19-1.72-.39-3.59-.61-5.56-.14-1.36-.28-2.66-.4-3.88a.18.18,0,0,1,.16-.2.16.16,0,0,1,.17.08,2.75,2.75,0,0,1,.23,2.26,3.14,3.14,0,0,1-1.23,1.67,2.35,2.35,0,0,1-1.81.35,2.83,2.83,0,0,1-1.39-.75,2.88,2.88,0,0,1-.92-2,1.78,1.78,0,0,1,.07-.59c0-.13.06-.19.07-.19s-.06.28,0,.77a2.85,2.85,0,0,0,.95,1.83,2.68,2.68,0,0,0,1.29.65,2.11,2.11,0,0,0,1.59-.34,2.84,2.84,0,0,0,1.07-1.51,2.38,2.38,0,0,0-.21-2l.34-.12c.13,1.22.27,2.53.42,3.88.2,2,.39,3.85.57,5.56q.13,1.29.24,2.43a10.54,10.54,0,0,1,.08,2.15,2.62,2.62,0,0,1-.71,1.66,2,2,0,0,1-1.24.55,1.29,1.29,0,0,1-.83-.22A.6.6,0,0,1,355.08,137.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4,201.41c-.11,0-.19-17.58-.19-39.26s.08-39.26.19-39.26.19,17.57.19,39.26S363.5,201.41,363.4,201.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.31,201.94a9.57,9.57,0,0,1-1,.74c-.64.46-1.59,1.1-2.78,1.86-2.37,1.53-5.73,3.53-9.48,5.65l-9.6,5.41-2.9,1.66a6.5,6.5,0,0,1-1.08.57,8.7,8.7,0,0,1,1-.7c.66-.43,1.63-1,2.84-1.76,2.41-1.47,5.8-3.39,9.55-5.51s7.11-4.07,9.52-5.55l2.84-1.75A6.9,6.9,0,0,1,363.31,201.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.35,201.94c0,.1-16.36.19-36.52.19s-36.52-.09-36.52-.19,16.34-.19,36.52-.19S436.35,201.83,436.35,201.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.19,172.14a4.37,4.37,0,0,1-.19-1.81,4.65,4.65,0,0,1,.19-1.82,4.44,4.44,0,0,1,.19,1.82A4.58,4.58,0,0,1,351.19,172.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.15,179.39a4.28,4.28,0,0,1-.18-1.81,4.69,4.69,0,0,1,.2-1.81,4.28,4.28,0,0,1,.18,1.81A4.69,4.69,0,0,1,351.15,179.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.08,186.65a4.65,4.65,0,0,1-.17-1.82,4.37,4.37,0,0,1,.21-1.81,4.61,4.61,0,0,1,.17,1.82A4.37,4.37,0,0,1,351.08,186.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,193.9a4.61,4.61,0,0,1-.17-1.82,4.37,4.37,0,0,1,.21-1.81,4.65,4.65,0,0,1,.17,1.82A4.37,4.37,0,0,1,351,193.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,201.15a4.58,4.58,0,0,1-.17-1.81,4.72,4.72,0,0,1,.2-1.82,4.81,4.81,0,0,1,.18,1.82A4.37,4.37,0,0,1,351,201.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.93,208.4a4.37,4.37,0,0,1-.19-1.81,4.58,4.58,0,0,1,.19-1.81,4.37,4.37,0,0,1,.19,1.81A4.58,4.58,0,0,1,350.93,208.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.54,209.49a8.72,8.72,0,0,1-3.62,0,8.72,8.72,0,0,1,3.62,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,209.49a8.72,8.72,0,0,1-3.62,0,8.72,8.72,0,0,1,3.62,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,209.49a4.58,4.58,0,0,1-1.81.19,4.65,4.65,0,0,1-1.82-.19,4.44,4.44,0,0,1,1.82-.19A4.37,4.37,0,0,1,369,209.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28,209.49a8.72,8.72,0,0,1-3.62,0,8.72,8.72,0,0,1,3.62,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.54,209.49a8.76,8.76,0,0,1-3.63,0,8.76,8.76,0,0,1,3.63,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,209.49a8.72,8.72,0,0,1-3.62,0,8.72,8.72,0,0,1,3.62,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.76,209.49c0,.1-.3.19-.67.19s-.67-.09-.67-.19.3-.19.67-.19S395.76,209.38,395.76,209.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.76,209.49c-.1,0-.19-9.29-.19-20.75s.09-20.76.19-20.76.19,9.29.19,20.76S395.86,209.49,395.76,209.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.56,168a4.44,4.44,0,0,1-1.82.19,4.37,4.37,0,0,1-1.81-.19,4.69,4.69,0,0,1,1.81-.18A4.76,4.76,0,0,1,354.56,168Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.81,168a8.76,8.76,0,0,1-3.63,0,9.24,9.24,0,0,1,3.63,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.06,168a4.37,4.37,0,0,1-1.81.19,4.44,4.44,0,0,1-1.82-.19,4.76,4.76,0,0,1,1.82-.18A4.69,4.69,0,0,1,369.06,168Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,168a8.72,8.72,0,0,1-3.62,0,9.19,9.19,0,0,1,3.62,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.57,168a8.76,8.76,0,0,1-3.63,0,9.24,9.24,0,0,1,3.63,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82,168a4.37,4.37,0,0,1-1.81.19,4.44,4.44,0,0,1-1.82-.19,4.76,4.76,0,0,1,1.82-.18A4.69,4.69,0,0,1,390.82,168Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.76,168c0,.11-.29.19-.66.19s-.65-.08-.65-.19.29-.18.65-.18S395.76,167.88,395.76,168Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44,165.54c.07.07-.48.68-1.22,1.36s-1.39,1.16-1.46,1.08.47-.68,1.21-1.36S398.36,165.46,398.44,165.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.79,160.64c.07.08-.48.69-1.21,1.36s-1.4,1.17-1.47,1.09.47-.69,1.21-1.36S403.72,160.56,403.79,160.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,156.58c.07.07-.27.5-.76.94s-.94.75-1,.67.27-.5.76-.94S408.16,156.5,408.23,156.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.41,198.31a8.76,8.76,0,0,1,0,3.63,4.58,4.58,0,0,1-.19-1.81A4.4,4.4,0,0,1,408.41,198.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.38,191.06a4.28,4.28,0,0,1,.2,1.81,4.76,4.76,0,0,1-.18,1.82,4.54,4.54,0,0,1-.2-1.82A4.69,4.69,0,0,1,408.38,191.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.35,183.81a9.19,9.19,0,0,1,0,3.62,8.72,8.72,0,0,1,0-3.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3,176.55a8.77,8.77,0,0,1,0,3.63,4.69,4.69,0,0,1-.2-1.81A4.76,4.76,0,0,1,408.3,176.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,169.3a8.76,8.76,0,0,1,0,3.63,4.69,4.69,0,0,1-.2-1.81A4.76,4.76,0,0,1,408.26,169.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,162.05a4.28,4.28,0,0,1,.2,1.81,4.76,4.76,0,0,1-.18,1.82,4.34,4.34,0,0,1-.2-1.82A4.69,4.69,0,0,1,408.23,162.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,156.58c.1,0,.19.41.19.92s-.09.92-.19.92-.19-.41-.19-.92S408.12,156.58,408.23,156.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.87,207.63c.06.09-.6.58-1.46,1.09a4.64,4.64,0,0,1-1.65.77c-.05-.09.6-.58,1.46-1.09A4.43,4.43,0,0,1,398.87,207.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.1,203.91c.06.09-.6.58-1.46,1.09a4.43,4.43,0,0,1-1.65.77c-.06-.09.6-.58,1.46-1.09A4.64,4.64,0,0,1,405.1,203.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.41,201.94c0,.09,0,.19,0,.22s-.14,0-.19-.11-.06-.18,0-.22S408.36,201.85,408.41,201.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.16,165.36A4.68,4.68,0,0,1,353,166.8c-.69.73-1.31,1.26-1.39,1.18a4.81,4.81,0,0,1,1.12-1.44C353.46,165.82,354.08,165.29,354.16,165.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.08,160a4.55,4.55,0,0,1-1.09,1.46c-.68.74-1.29,1.28-1.37,1.21s.41-.73,1.09-1.46S359,160,359.08,160Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.6,156.31c.08.08-.1.37-.38.67s-.58.48-.66.41.1-.38.39-.67S362.53,156.24,362.6,156.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.41,
    cy: 156.31,
    rx: 1.81,
    ry: 0.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.48,156.31a4.37,4.37,0,0,1-1.81.19,4.44,4.44,0,0,1-1.82-.19,4.65,4.65,0,0,1,1.82-.19A4.58,4.58,0,0,1,373.48,156.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.92,
    cy: 156.31,
    rx: 1.81,
    ry: 0.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,156.31a4.44,4.44,0,0,1-1.82.19,4.37,4.37,0,0,1-1.81-.19,4.58,4.58,0,0,1,1.81-.19A4.65,4.65,0,0,1,388,156.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 393.43,
    cy: 156.31,
    rx: 1.81,
    ry: 0.19,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,156.31a8.72,8.72,0,0,1-3.62,0,8.72,8.72,0,0,1,3.62,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,156.31c0,.11-.65.19-1.45.19s-1.45-.08-1.45-.19a5.63,5.63,0,0,1,2.9,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,176.49c-.1,0-.19-3.39-.19-7.57s.09-7.57.19-7.57a73.8,73.8,0,0,1,.19,7.57A73.8,73.8,0,0,1,379.31,176.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.39,183.37c0,.1-4.52.19-10.08.19s-10.08-.09-10.08-.19,4.51-.19,10.08-.19S373.39,183.27,373.39,183.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.31,205.38c-.1,0-.19-3.92-.19-8.75s.09-8.76.19-8.76.19,3.92.19,8.76S379.42,205.38,379.31,205.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,182.9c0,.1-3.33.19-7.43.19S385,183,385,182.9s3.33-.19,7.43-.19S399.87,182.8,399.87,182.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.24,176.63a3.81,3.81,0,0,1,1.49-.14,6,6,0,0,1,3.7,1.68,5.79,5.79,0,0,1,1.54,2.39,5.19,5.19,0,0,1,0,3.28,6.38,6.38,0,0,1-2.1,2.95,5.4,5.4,0,0,1-7.23-.24,6.09,6.09,0,0,1-1.2-1.44,5.64,5.64,0,0,1-.7-1.64,5.18,5.18,0,0,1,.17-3.27,6,6,0,0,1,1.69-2.3,6,6,0,0,1,3.78-1.47,3.84,3.84,0,0,1,1.49.22,13.92,13.92,0,0,0-1.48-.08,6.17,6.17,0,0,0-3.62,1.53,6,6,0,0,0-1.57,2.21,4.92,4.92,0,0,0-.13,3.07,5.41,5.41,0,0,0,.68,1.54,5.6,5.6,0,0,0,1.13,1.35,5.4,5.4,0,0,0,3.34,1.41,5.33,5.33,0,0,0,3.42-1.19,5.44,5.44,0,0,0,1.22-1.27,5.59,5.59,0,0,0,.78-1.49,5,5,0,0,0,.06-3.07,5.76,5.76,0,0,0-1.44-2.3,6,6,0,0,0-3.52-1.73A11.23,11.23,0,0,0,378.24,176.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,285.86c0,.11-24,.19-53.67.19s-53.68-.08-53.68-.19,24-.19,53.68-.19S366.81,285.76,366.81,285.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.77,285.59a1.31,1.31,0,0,1-.1-.3c-.06-.22-.15-.52-.25-.9-.22-.8-.56-2-1-3.45a66.49,66.49,0,0,0-5.23-12.13A47.94,47.94,0,0,0,331.55,254a39.78,39.78,0,0,0-10-5.64,34.05,34.05,0,0,0-12.12-2.23,37.86,37.86,0,0,0-29.87,14.58,41.89,41.89,0,0,0-4.8,7.73A44.2,44.2,0,0,0,270.86,281c-.21,1.54-.34,2.75-.38,3.57,0,.4-.05.71-.07.94l0,.32a1.57,1.57,0,0,1,0-.32l0-.94c0-.82.12-2,.32-3.59a43.2,43.2,0,0,1,3.76-12.69,41.25,41.25,0,0,1,4.8-7.8,37.3,37.3,0,0,1,7.52-7.35,38.32,38.32,0,0,1,22.59-7.42A34.3,34.3,0,0,1,321.64,248a40,40,0,0,1,10.12,5.71,48,48,0,0,1,12.63,15,64.1,64.1,0,0,1,5.14,12.21c.45,1.5.77,2.68,1,3.48.09.39.16.69.22.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.49,284.43c.08.06-.1.44-.41.83s-.62.66-.7.6.09-.44.4-.83S271.41,284.36,271.49,284.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,279.2c.07.08-.48.71-1.22,1.39a4.92,4.92,0,0,1-1.47,1.11c-.08-.07.47-.69,1.22-1.39S276.56,279.12,276.63,279.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.67,275.06a5.4,5.4,0,0,1-1.49,1.07,5.54,5.54,0,0,1-1.64.85c-.06-.09.57-.63,1.44-1.17A4.13,4.13,0,0,1,282.67,275.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,272.39a10.51,10.51,0,0,1-3.49,1.13,4.1,4.1,0,0,1,1.68-.77A4.59,4.59,0,0,1,289.49,272.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.62,270.7a9.17,9.17,0,0,1-3.59.76,4.59,4.59,0,0,1,1.76-.57A4.37,4.37,0,0,1,296.62,270.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.89,269.74a9.36,9.36,0,0,1-3.65.38,4.41,4.41,0,0,1,1.81-.38A4.33,4.33,0,0,1,303.89,269.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22,269.68a4.38,4.38,0,0,1-1.83.14,5,5,0,0,1-1.83-.22,4.22,4.22,0,0,1,1.84-.16A4.66,4.66,0,0,1,311.22,269.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.54,270.26a4.5,4.5,0,0,1-1.85,0,4.69,4.69,0,0,1-1.8-.37,4.62,4.62,0,0,1,1.84,0A4.71,4.71,0,0,1,318.54,270.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.76,271.49a4.44,4.44,0,0,1-1.83-.16,4.85,4.85,0,0,1-1.77-.54,9.21,9.21,0,0,1,3.6.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,273.43a4.89,4.89,0,0,1-1.8-.37,5.45,5.45,0,0,1-1.71-.7,4.21,4.21,0,0,1,1.82.34A4.39,4.39,0,0,1,332.83,273.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,276.35a4.76,4.76,0,0,1-1.73-.63,4.66,4.66,0,0,1-1.57-1,4.49,4.49,0,0,1,1.74.62A4.7,4.7,0,0,1,339.55,276.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.71,280.32a4.5,4.5,0,0,1-1.6-.9c-.83-.58-1.45-1.12-1.39-1.21a4.57,4.57,0,0,1,1.61.9C345.16,279.7,345.78,280.24,345.71,280.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.81,284c-.07.07-.42-.15-.78-.5s-.59-.69-.51-.77.42.15.78.5S349.89,283.89,349.81,284Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.61,288.76c-.07.07-.7-.46-1.32-1.26a3.52,3.52,0,0,1-.86-1.63c.1-.05.56.61,1.16,1.4S272.69,288.69,272.61,288.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,293.33a4.64,4.64,0,0,1-1.58-.91c-.82-.58-1.43-1.13-1.36-1.21a4.75,4.75,0,0,1,1.58.91C277.68,292.7,278.29,293.24,278.23,293.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.64,296.72a4.69,4.69,0,0,1-1.72-.61,4.49,4.49,0,0,1-1.56-.95,4.58,4.58,0,0,1,1.72.61A4.4,4.4,0,0,1,284.64,296.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.56,298.84a4.66,4.66,0,0,1-1.81-.24A4.21,4.21,0,0,1,288,298a5,5,0,0,1,1.8.27A4.73,4.73,0,0,1,291.56,298.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,300.19a4.56,4.56,0,0,1-1.82-.12,4.62,4.62,0,0,1-1.76-.49,4.56,4.56,0,0,1,1.82.12A4.69,4.69,0,0,1,298.69,300.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.9,301a4.81,4.81,0,0,1-1.83,0,4.6,4.6,0,0,1-1.79-.35,4.58,4.58,0,0,1,1.83,0A4.51,4.51,0,0,1,305.9,301Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.15,301.12a4.5,4.5,0,0,1-1.82.2,4.69,4.69,0,0,1-1.81-.18,4.28,4.28,0,0,1,1.81-.2A4.81,4.81,0,0,1,313.15,301.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.37,300.53a8.9,8.9,0,0,1-3.6.39,4.7,4.7,0,0,1,1.78-.38A4.57,4.57,0,0,1,320.37,300.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.48,299.11a4.42,4.42,0,0,1-1.72.59,4.53,4.53,0,0,1-1.81.23,8.94,8.94,0,0,1,3.53-.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.34,296.79a4.58,4.58,0,0,1-1.63.81,4.44,4.44,0,0,1-1.76.47,4.54,4.54,0,0,1,1.63-.82A4.45,4.45,0,0,1,334.34,296.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.8,293.52c.06.09-.61.55-1.49,1a4.44,4.44,0,0,1-1.68.71,4.62,4.62,0,0,1,1.5-1A4.56,4.56,0,0,1,340.8,293.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72,289.33c.06.08-.53.64-1.33,1.26a4.6,4.6,0,0,1-1.55,1c-.06-.09.53-.65,1.32-1.25A4.53,4.53,0,0,1,346.72,289.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.77,285.59c.07.08-.17.43-.54.8s-.73.61-.8.53.17-.43.53-.79S350.69,285.52,350.77,285.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.53,307.56c-.1,0-.19-16.87-.19-37.69s.09-37.69.19-37.69.19,16.88.19,37.69S308.64,307.56,308.53,307.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.56,249.34c.07.07-7.48,8.09-16.86,17.9S308.63,285,308.56,284.88s7.47-8.09,16.86-17.9S342.48,249.27,342.56,249.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.5,249.1a8.4,8.4,0,0,1,1.53-.62c1-.36,2.35-.84,4-1.39l.28-.09,0,.29c-.13.82-.27,1.69-.42,2.6s-.26,1.55-.38,2.27l0,.19-.19,0a10,10,0,0,1-4-2,9.08,9.08,0,0,1-.93-.91c-.2-.23-.29-.36-.28-.38s.48.46,1.35,1.11a10.73,10.73,0,0,0,3.94,1.82l-.23.15c.12-.72.24-1.48.37-2.27s.3-1.78.44-2.6l.23.2c-1.61.53-3,1-4,1.26A8.46,8.46,0,0,1,340.5,249.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.2,256.2a39.7,39.7,0,0,1,2.64-4.83,40.86,40.86,0,0,1,3-4.64,40.4,40.4,0,0,1-2.63,4.83A40.05,40.05,0,0,1,351.2,256.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.35,258.77a47.49,47.49,0,0,1-3.29-4.92,45.82,45.82,0,0,1-3-5.13,49,49,0,0,1,3.29,4.93A45.22,45.22,0,0,1,357.35,258.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42,256.74a13.92,13.92,0,0,0-2.61-4.08l.3,0a7.18,7.18,0,0,0-.28,4.79l-.33.06c-.06-1.13-.11-2.08-.13-2.75a3.62,3.62,0,0,1,0-1.05,3.58,3.58,0,0,1,.17,1c.08.66.17,1.61.27,2.74l.12,1.49-.45-1.43a7.23,7.23,0,0,1,.26-5l.11-.25.19.19a10.17,10.17,0,0,1,2,3A4,4,0,0,1,362.42,256.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.09,284.52s.2-.07.51-.25a2.59,2.59,0,0,0,1-1.07A3.47,3.47,0,0,0,323,281a8.19,8.19,0,0,0-.85-2.64c-.1-.22-.2-.44-.3-.64l.33-.18a2.06,2.06,0,0,1-.54,2.58,1.71,1.71,0,0,1-1.16.37,2,2,0,0,1-1.78-1.56c-.05-.34,0-.53,0-.52s0,.19.11.49a1.87,1.87,0,0,0,.81,1,1.67,1.67,0,0,0,.84.27,1.38,1.38,0,0,0,.93-.33,1.73,1.73,0,0,0,.44-2.12l.33-.18.31.64a8.26,8.26,0,0,1,.85,2.77,3.76,3.76,0,0,1-.52,2.32,2.71,2.71,0,0,1-1.2,1.08A1,1,0,0,1,321.09,284.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.88,256.9a9.08,9.08,0,0,1-1.11.15c-.72.07-1.75.16-3,.24-2.56.17-6.11.33-10,.34s-7.48-.12-10.05-.28c-1.28-.08-2.32-.16-3-.23a5.68,5.68,0,0,1-1.11-.15,8,8,0,0,1,1.12,0l3,.11c2.56.09,6.11.18,10,.17s7.46-.12,10-.23l3-.12A5.41,5.41,0,0,1,335.88,256.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.89,250.09a3.52,3.52,0,0,1-1.91.38,3.47,3.47,0,0,1-1.9-.38,9.23,9.23,0,0,1,1.9,0A9.34,9.34,0,0,1,315.89,250.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.08,254.26s.14.11.37.34a4.14,4.14,0,0,0,1.06.81,1.87,1.87,0,0,0,1.81,0,1.67,1.67,0,0,0,.87-1.9,1.6,1.6,0,0,0-1.47-1.26,1.67,1.67,0,0,0-1.48.77l-.11.18L313,253a1.45,1.45,0,0,1-.11-1.64c.22-.34.45-.42.45-.4s-.16.15-.31.48a1.3,1.3,0,0,0,.18,1.37l-.23,0a1.93,1.93,0,0,1,3.56.54,1.9,1.9,0,0,1-.14,1.39,2.18,2.18,0,0,1-2.07,1.15,2.36,2.36,0,0,1-1-.31,3.66,3.66,0,0,1-1-1C312.14,254.44,312.06,254.27,312.08,254.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.44,255.17a17.14,17.14,0,0,1,2.54-4.35,17.14,17.14,0,0,1-2.54,4.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.69,256.25a6.76,6.76,0,0,1-2.24-1.88,7,7,0,0,1-1.57-2.47c.1-.06.81,1,1.85,2.22S321.76,256.17,321.69,256.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.5,242.93a2.45,2.45,0,0,0,.84.6,2.41,2.41,0,0,0,2.55-.64,6.49,6.49,0,0,0,1.36-3.91,23.06,23.06,0,0,0-.26-5.23c-.08-.54-.16-1.07-.24-1.58l.37,0a9.11,9.11,0,0,1,0,2.5,3.31,3.31,0,0,1-1.13,2,2.07,2.07,0,0,1-2.05.43,2.7,2.7,0,0,1-1.4-1.17,4.86,4.86,0,0,1-.57-2.5,4.43,4.43,0,0,1,.06-.92,5.34,5.34,0,0,1,.08.92,5,5,0,0,0,.64,2.36,2.5,2.5,0,0,0,1.28,1,1.81,1.81,0,0,0,1.75-.4,3,3,0,0,0,1-1.86,9.23,9.23,0,0,0,0-2.4l.37,0q.12.76.24,1.59a22,22,0,0,1,.24,5.31,6.61,6.61,0,0,1-1.52,4.06,2.61,2.61,0,0,1-1.53.77,2.5,2.5,0,0,1-1.27-.17,1.61,1.61,0,0,1-.64-.5A1,1,0,0,1,288.5,242.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92,242.07s-.16.24-.63.23a1.58,1.58,0,0,1-1.39-1.14,3.82,3.82,0,0,1-.12-1.28,10.7,10.7,0,0,0,.1-1.39,1.17,1.17,0,0,0-.19-.64.8.8,0,0,0-.52-.36c-.42-.08-.73.43-.85.95a11.25,11.25,0,0,0-.26,3.85l-.33,0c-.11-1.31-.19-2.41-.23-3.18a5.09,5.09,0,0,1,0-1.23,5.42,5.42,0,0,1,.21,1.21c.1.76.23,1.86.37,3.17l-.33,0a10.71,10.71,0,0,1,.22-4,2.32,2.32,0,0,1,.38-.85,1,1,0,0,1,.9-.38,1.35,1.35,0,0,1,1,1.35,11.48,11.48,0,0,1-.13,1.43,3.24,3.24,0,0,0,.06,1.18,1.31,1.31,0,0,0,1.76,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.1,137.64a1.34,1.34,0,0,1-.21.28,9.56,9.56,0,0,1-.68.71,10.87,10.87,0,0,1-3,2,5.68,5.68,0,0,1-2.47.49,2.79,2.79,0,0,1-2.43-1.54,5.31,5.31,0,0,1-.29-3.19,11.11,11.11,0,0,1,3.08-6,2.15,2.15,0,0,1,.69-.55.85.85,0,0,1,.92.22,1.19,1.19,0,0,1,.35.81,3,3,0,0,1-.06.8,9.22,9.22,0,0,1-2.39,4.77,9,9,0,0,1-2.93,2.1,7.09,7.09,0,0,1-.92.34,1.19,1.19,0,0,1-.34.07s.44-.17,1.2-.54a9.44,9.44,0,0,0,2.79-2.15,9.16,9.16,0,0,0,2.25-4.65,1.44,1.44,0,0,0-.2-1.3.49.49,0,0,0-.54-.13,1.94,1.94,0,0,0-.56.47,10.73,10.73,0,0,0-1.93,2.68,10.88,10.88,0,0,0-1,3.13,5,5,0,0,0,.23,3,2.47,2.47,0,0,0,2.14,1.38,5.44,5.44,0,0,0,2.35-.43,11.71,11.71,0,0,0,3-1.85C447.76,138,448.07,137.62,448.1,137.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.24,138.71a2.65,2.65,0,0,1-.71,1.11,2,2,0,0,1-1.35.65,1.44,1.44,0,0,1-.9-.24,1.39,1.39,0,0,1-.52-.87,9.84,9.84,0,0,1,.16-3.19,3.14,3.14,0,0,1,.4-1.25,5.94,5.94,0,0,1-.14,1.29,13.78,13.78,0,0,0-.06,3.07,1,1,0,0,0,1.05.84,1.77,1.77,0,0,0,1.17-.49C449.91,139.1,450.19,138.66,450.24,138.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,130.88s-.23-.27,0-.66a.65.65,0,0,1,.76-.23.72.72,0,0,1-.31,1.4.63.63,0,0,1-.55-.59.61.61,0,0,1,.18-.48c.1-.08.17-.09.18-.07s-.17.21-.09.52a.32.32,0,0,0,.31.27.41.41,0,0,0,.41-.29.44.44,0,0,0-.26-.44.4.4,0,0,0-.43.09C447.78,130.62,447.82,130.87,447.77,130.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.71,141.55s-.07-.07-.17-.23-.22-.41-.37-.73a10,10,0,0,1-.77-3c-.09-.62.08-1.43-.43-1.89a.63.63,0,0,0-.88,0,3.94,3.94,0,0,0-.74.93,11.1,11.1,0,0,0-1.76,5.21.19.19,0,0,1-.2.17.2.2,0,0,1-.18-.18,12.12,12.12,0,0,0-.25-2.11,10.2,10.2,0,0,0-.36-1.37,5.46,5.46,0,0,0-.52-1.25.69.69,0,0,0-.95-.27,2.86,2.86,0,0,0-.86.87,8.3,8.3,0,0,0-1.55,4.28.15.15,0,0,1-.29,0h0c.12-1.86.22-3.39.3-4.53,0-.5.08-.91.11-1.24a1.72,1.72,0,0,1,.06-.44,1.49,1.49,0,0,1,0,.44c0,.33,0,.75,0,1.25,0,1.14-.11,2.67-.18,4.53h-.29a8.38,8.38,0,0,1,1.55-4.47,3.08,3.08,0,0,1,1-1,1,1,0,0,1,.79-.11,1.16,1.16,0,0,1,.63.49,6,6,0,0,1,.58,1.34,12.84,12.84,0,0,1,.37,1.42,12.71,12.71,0,0,1,.26,2.17h-.38a11.43,11.43,0,0,1,1.86-5.36,4.17,4.17,0,0,1,.83-1,1.06,1.06,0,0,1,.64-.25.89.89,0,0,1,.63.25,1.54,1.54,0,0,1,.44,1.08c0,.37,0,.69,0,1a10.73,10.73,0,0,0,.65,2.91C460.55,141.19,460.73,141.54,460.71,141.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.41,149.65s0,.08-.06.22a2.3,2.3,0,0,1-.34.56.91.91,0,0,1-1,.37,1.43,1.43,0,0,1-.79-1.15,30.85,30.85,0,0,1-.65-3.44,3.11,3.11,0,0,0-.07-.47c0-.13-.12-.27-.19-.29s-.12,0-.2.14-.16.29-.24.45a7.92,7.92,0,0,0-.64,2.05,22.53,22.53,0,0,0-.29,3.28.18.18,0,0,1-.36,0,53.62,53.62,0,0,1-.86-5.45c-.07-.68-.1-1.22-.12-1.59a1.79,1.79,0,0,1,0-.57s.14.79.34,2.13.5,3.24,1,5.4l-.35,0a22.16,22.16,0,0,1,.27-3.34,8.19,8.19,0,0,1,.69-2.15c.08-.16.16-.32.26-.48a.74.74,0,0,1,.25-.25.45.45,0,0,1,.41,0,.77.77,0,0,1,.38.52,3.9,3.9,0,0,1,.08.52c.15,1.3.35,2.46.56,3.43.09.47.27.9.59,1a.76.76,0,0,0,.81-.27C445.26,149.93,445.38,149.63,445.41,149.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.93,147.92a13.08,13.08,0,0,1-3.14.61,13.92,13.92,0,0,1-3.19.23,13.86,13.86,0,0,1,3.14-.6A13.61,13.61,0,0,1,454.93,147.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.18,150.25s.15-.39.6-.88a6.5,6.5,0,0,1,2.13-1.53l0,.35-.42-.16a7.88,7.88,0,0,1-3.4-2.26,26.29,26.29,0,0,0,3.54,1.91l.4.15h0a.21.21,0,0,1,.11.25.19.19,0,0,1-.1.1A11.46,11.46,0,0,0,452.18,150.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.4,145.8a.73.73,0,0,1,.18-.23,1.26,1.26,0,0,1,.79-.28,1.54,1.54,0,0,1,1.21.55,1.81,1.81,0,0,1,.2,1.74,2.3,2.3,0,0,1-1.6,1.39,3.79,3.79,0,0,1-2.43-.16,7.59,7.59,0,0,1-2.25-1.45,4.27,4.27,0,0,0-2.28-1.34,2,2,0,0,0-1.91,1.41,1.79,1.79,0,0,0,.92,2,1.87,1.87,0,0,0,1.07.26,2.4,2.4,0,0,0,1-.38,10.9,10.9,0,0,0,1.56-1.31,15.66,15.66,0,0,0,1.9-2.28,9.41,9.41,0,0,1,.63-.9s0,.1-.11.27-.21.41-.39.71A14.27,14.27,0,0,1,462,148.2a11.07,11.07,0,0,1-1.58,1.38,2.52,2.52,0,0,1-1.13.45,2.18,2.18,0,0,1-1.28-.29,2.31,2.31,0,0,1-.95-1,2,2,0,0,1-.15-1.43,2.33,2.33,0,0,1,2.3-1.69,2.87,2.87,0,0,1,1.41.55c.4.28.74.6,1.08.89a7.4,7.4,0,0,0,2.13,1.4,3.54,3.54,0,0,0,2.23.19,2,2,0,0,0,1.43-1.18,1.6,1.6,0,0,0-.12-1.52,1.37,1.37,0,0,0-2-.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.78,140.68c0,.1-6,.19-13.36.19s-13.37-.09-13.37-.19,6-.19,13.37-.19S497.78,140.58,497.78,140.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.87,137.05a14.47,14.47,0,0,1-1-2.05c-.14-.33-.3-.68-.46-1.05s-.32-.87-.61-1-.29,0-.42.21a5.08,5.08,0,0,0-.33.62,15.41,15.41,0,0,0-.57,1.44c-.16.5-.29,1-.4,1.49a.18.18,0,0,1-.21.15.21.21,0,0,1-.15-.15c-.35-1.72-.77-3.21-1.09-4.27a13.92,13.92,0,0,1-.49-1.71,8,8,0,0,1,.72,1.63,32.84,32.84,0,0,1,1.22,4.28h-.36a11.34,11.34,0,0,1,.41-1.54,14.06,14.06,0,0,1,.58-1.47,4,4,0,0,1,.39-.69.75.75,0,0,1,.8-.33,1,1,0,0,1,.55.58c.08.21.16.41.25.6.14.38.29.73.42,1.07A12.71,12.71,0,0,1,475.87,137.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.84,132.53a10.14,10.14,0,0,0-1.57.32,4.9,4.9,0,0,1-1.78.25,2.37,2.37,0,0,1-1.05-.37,1.4,1.4,0,0,1-.66-1c0-.91.54-1.51.74-2.08a1,1,0,0,0-.3-1.35,1,1,0,0,0-1,.22c-.23.16-.35.26-.37.24s.07-.15.27-.35a1.61,1.61,0,0,1,.44-.31.91.91,0,0,1,.75-.05,1.3,1.3,0,0,1,.52,1.72c-.24.66-.75,1.25-.69,1.92s.78,1,1.37,1.1a5,5,0,0,0,1.68-.16A2.72,2.72,0,0,1,483.84,132.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.45,135.49a12.66,12.66,0,0,1-6.34.61c0-.11,1.43-.1,3.17-.28S488.42,135.39,488.45,135.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.21,138.29a19,19,0,0,1,2-3.12,18.24,18.24,0,0,1,2.27-2.89,17.6,17.6,0,0,1-2,3.11A18,18,0,0,1,490.21,138.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.43,137.74a12,12,0,0,1-3.82-2.53,12.3,12.3,0,0,1-2.9-3.54c.09-.07,1.29,1.59,3.15,3.26S496.49,137.64,496.43,137.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.33,150.76a3.32,3.32,0,0,1,.63.14,6,6,0,0,0,1.71.24,2.64,2.64,0,0,0,2.14-1,1.73,1.73,0,0,0,.23-1.34,1.16,1.16,0,0,0-1-.91,1.05,1.05,0,0,0-1.08.47l-.24-.26a4.56,4.56,0,0,0,1.18-.64,1.47,1.47,0,0,0,.55-1,.9.9,0,0,0-.42-.84,1.49,1.49,0,0,0-.87-.24,2.9,2.9,0,0,0-1.29.44,1.9,1.9,0,0,1-.46.23s.11-.14.39-.34a2.8,2.8,0,0,1,1.35-.58,1.74,1.74,0,0,1,1,.24,1.22,1.22,0,0,1,.6,1.11,1.83,1.83,0,0,1-.65,1.23,4.75,4.75,0,0,1-1.26.71.19.19,0,0,1-.24-.26,1.43,1.43,0,0,1,1.45-.66,1.52,1.52,0,0,1,.86.39,1.57,1.57,0,0,1,.45.8,2.07,2.07,0,0,1-.3,1.62,2.88,2.88,0,0,1-2.42,1.13,5.12,5.12,0,0,1-1.76-.37A1.87,1.87,0,0,1,479.33,150.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,181.51c-.08-.06,2.21-2.87,5.12-6.25s5.33-6.09,5.41-6-2.22,2.87-5.13,6.26S449.16,181.58,449.09,181.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.33,183.52c-.09,0-2.26-3.12-4.85-7.09s-4.63-7.24-4.54-7.3,2.26,3.12,4.85,7.09S459.42,183.46,459.33,183.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.25,180.36s-.06,0-.17-.07a1,1,0,0,1-.37-.38,3.29,3.29,0,0,1-.18-1.91,7.53,7.53,0,0,0,0-1.27,1.51,1.51,0,0,0-.57-1.17,1.8,1.8,0,0,0-2.43,1.2,5.57,5.57,0,0,0,.5,3.36l-.32.14a7.17,7.17,0,0,1-.77-3.75,7.06,7.06,0,0,1,.17-1.07c.07-.25.12-.37.14-.37s-.09.54-.1,1.45a7.45,7.45,0,0,0,.87,3.58l-.32.14a13.31,13.31,0,0,1-.54-1.65,3.94,3.94,0,0,1,0-1.93,2.32,2.32,0,0,1,1.23-1.42,1.78,1.78,0,0,1,1.76,0,1.85,1.85,0,0,1,.7,1.43,7.65,7.65,0,0,1-.09,1.33,3.39,3.39,0,0,0,0,1.81C465,180.22,465.28,180.33,465.25,180.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.42,180s.19-.21.66-.26a1.73,1.73,0,0,1,1.63.85l0,0v0a1.3,1.3,0,0,1-.69,1,1.89,1.89,0,0,1-1.33.17,1.37,1.37,0,0,1-.89-.63,1.19,1.19,0,0,1-.07-1,1.71,1.71,0,0,1,1.29-1,1.31,1.31,0,0,1,1.06.21c.21.17.24.32.23.33s-.11-.1-.31-.2a1.18,1.18,0,0,0-.92-.08,1.49,1.49,0,0,0-1,.84.83.83,0,0,0,.06.72,1,1,0,0,0,.66.44,1.56,1.56,0,0,0,1.07-.12.94.94,0,0,0,.53-.72l0,.09a1.56,1.56,0,0,0-1.34-.81C504.67,179.94,504.44,180.06,504.42,180Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.84,175.14s.1-.08.32-.06a1.15,1.15,0,0,1,.77.46,1.34,1.34,0,0,1,.23,1.33,1.06,1.06,0,0,1-.62.59,1.39,1.39,0,0,1-.9,0,1.28,1.28,0,0,1-1-1.19v0h0a1.43,1.43,0,0,1,.63-.93,1.56,1.56,0,0,1,.81-.27c.5,0,.72.23.7.24s-.26-.09-.68,0a1.33,1.33,0,0,0-1.11,1v0a1,1,0,0,0,.73.83.86.86,0,0,0,1.09-.37,1.12,1.12,0,0,0-.13-1A1.32,1.32,0,0,0,467.84,175.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.63,168.35a6.14,6.14,0,0,1-.1,1.15c-.11.8-.25,1.86-.42,3.12s-.43,2.91-.68,4.63c-.06.44-.13.89-.2,1.34a1.43,1.43,0,0,1-.32.73.71.71,0,0,1-.88.09,1.88,1.88,0,0,1-.55-.58l-.41-.62c-.27-.42-.53-.85-.79-1.29a29.21,29.21,0,0,1-2.43-5.46l.33-.06c0,2.53,0,4.7,0,6.32,0,.72,0,1.32,0,1.8a3,3,0,0,1,0,.64,3.1,3.1,0,0,1-.07-.64c0-.48,0-1.08-.08-1.8,0-1.61-.1-3.78-.17-6.31l0-1.14.37,1.08a31.87,31.87,0,0,0,2.44,5.38c.25.44.51.87.78,1.28a4,4,0,0,0,.83,1.08.33.33,0,0,0,.43,0,1,1,0,0,0,.23-.53c.07-.46.14-.9.21-1.33.28-1.72.53-3.28.75-4.62l.54-3.1A7.57,7.57,0,0,1,478.63,168.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.08,175.74a33.15,33.15,0,0,1-4.89.91,32.74,32.74,0,0,1-4.94.55,32.34,32.34,0,0,1,4.89-.92A32,32,0,0,1,490.08,175.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.92,179.41a7.7,7.7,0,0,1,1.2-1c.78-.61,1.88-1.43,3.14-2.36l0,.32-1.19-.58c-1.69-.83-3.21-1.6-4.3-2.17a9.53,9.53,0,0,1-1.73-1,10.52,10.52,0,0,1,1.85.76c1.12.51,2.66,1.24,4.35,2.07l1.18.58.28.14-.25.18c-1.27.91-2.4,1.7-3.21,2.25A7.41,7.41,0,0,1,486.92,179.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.6,183.11a5.27,5.27,0,0,1-.63-.54c-.39-.35-1-.87-1.75-1.49a34.07,34.07,0,0,0-6.84-4.32l-.56-.26.61-.06a12.86,12.86,0,0,0,3.93-.8,4,4,0,0,0,2.55-3.17,2.41,2.41,0,0,0-2.18-2.52,2,2,0,0,0-1.48.79,4.18,4.18,0,0,0-.71,1.58,16,16,0,0,0-.31,3.31c0,1.05-.07,2-.1,2.94-.08,1.75-.14,3.19-.18,4.24,0,.47-.05.85-.07,1.16a1.87,1.87,0,0,1-.05.4,2.12,2.12,0,0,1,0-.4v-1.16c0-1.06,0-2.5.06-4.25,0-.9,0-1.89.06-2.94a15.52,15.52,0,0,1,.28-3.38,4.48,4.48,0,0,1,.76-1.72,2.34,2.34,0,0,1,1.77-.94,2.43,2.43,0,0,1,1.85.91,2.88,2.88,0,0,1,.7,2,3.64,3.64,0,0,1-.94,2.16,5,5,0,0,1-1.83,1.32,12.9,12.9,0,0,1-4,.81l0-.33a31.93,31.93,0,0,1,6.83,4.47c.76.65,1.32,1.19,1.7,1.58A5,5,0,0,1,503.6,183.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.57,256.2c6.34.44,11.29,6.79,11.28,13.15A15.08,15.08,0,0,1,282.76,283a14.48,14.48,0,0,1-15.91-3.63c-3.85-4.35-5.4-11.95-2.3-16.86s10.54-8.22,16-6.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M551.66,69.23A14.63,14.63,0,0,1,549.91,71c-1.11,1.05-2.68,2.47-4.45,4s-3.4,2.87-4.61,3.81c-.61.46-1.11.83-1.47,1.07s-.56.37-.57.34a19.6,19.6,0,0,1,1.87-1.62c1.17-1,2.77-2.36,4.54-3.89s3.28-2.84,4.51-3.92A19.11,19.11,0,0,1,551.66,69.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.66,332.48c-.07.07-3-2.76-6.62-6.33s-6.44-6.52-6.36-6.59,3,2.76,6.62,6.32S551.73,332.41,551.66,332.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.13,80.22c-.07.08-2.94-2.55-6.4-5.88s-6.21-6.08-6.14-6.15,2.94,2.56,6.4,5.88S235.2,80.15,235.13,80.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.84,80.12c0,.1-63.84.19-142.59.19s-142.6-.09-142.6-.19,63.84-.19,142.6-.19S522.84,80,522.84,80.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.84,310.37c-.11,0-.19-47.81-.19-106.78s.08-106.78.19-106.78.19,47.8.19,106.78S539.94,310.37,539.84,310.37Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pens--inject-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.41,429.37s17.27-9.09,40.57,0l-12.39,12.76-12.35-3.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.66,391.17h5a0,0,0,0,1,0,0V460.7a2.24,2.24,0,0,1-2.24,2.24h-.48a2.24,2.24,0,0,1-2.24-2.24V391.17a0,0,0,0,1,0,0Z",
    transform: "translate(969.77 819.21) rotate(175.88)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.72,441.26l7.06-.51,1.67,23.12a3.55,3.55,0,0,1-3.28,3.79h0a3.54,3.54,0,0,1-3.78-3.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.66,
    y: 430.62,
    width: 1.37,
    height: 30.07,
    transform: "translate(965.59 856.47) rotate(175.87)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.78,440.75c0,.16-2.89.57-7.11,1l.31-.37c.13,1.61.27,3.36.41,5.2.25,3.42.43,6.52.52,8.76a16.14,16.14,0,0,1,0,3.64,17.65,17.65,0,0,1-.53-3.6c-.23-2.23-.49-5.32-.74-8.74-.12-1.85-.23-3.6-.34-5.21l0-.35.33,0C471.84,440.75,474.77,440.6,474.78,440.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.31,
    y: 393.1,
    width: 4.97,
    height: 56.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.24,415h-7.08V391.81a3.54,3.54,0,0,1,3.54-3.54h0a3.55,3.55,0,0,1,3.54,3.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.24,
    y: 395.6,
    width: 1.37,
    height: 30.07,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.16,415c0-.15,2.92-.35,7.16-.51l-.34.35c0-1.62,0-3.38,0-5.23,0-3.42,0-6.52.11-8.77a17.82,17.82,0,0,1,.27-3.63,17,17,0,0,1,.27,3.63c.07,2.25.11,5.35.11,8.77,0,1.85,0,3.61,0,5.23v.34h-.34C477.09,415.21,474.16,415.14,474.16,415Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 485.32,
    y: 406.25,
    width: 4.97,
    height: 56.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.24,428.14h-7.08V405a3.55,3.55,0,0,1,3.54-3.54h0a3.54,3.54,0,0,1,3.54,3.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.24,
    y: 408.75,
    width: 1.37,
    height: 30.07,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.16,428.14c0-.15,2.92-.35,7.17-.51L491,428c0-1.62,0-3.38,0-5.23,0-3.42.05-6.52.12-8.77a17,17,0,0,1,.27-3.63,17.82,17.82,0,0,1,.27,3.63c.07,2.25.11,5.35.11,8.77,0,1.85,0,3.61,0,5.23v.34h-.34C487.1,428.36,484.16,428.29,484.16,428.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.75,
    y: 391.05,
    width: 4.97,
    height: 56.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.67,412.94h-7.08V389.76a3.55,3.55,0,0,1,3.54-3.54h0a3.54,3.54,0,0,1,3.54,3.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500.67,
    y: 393.55,
    width: 1.37,
    height: 30.07,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.59,412.94c0-.16,2.93-.36,7.17-.51l-.34.34c0-1.61,0-3.37,0-5.22,0-3.42,0-6.53.11-8.77a17,17,0,0,1,.27-3.63,17,17,0,0,1,.27,3.63c.07,2.24.11,5.35.11,8.77,0,1.85,0,3.61,0,5.22v.35h-.34C496.53,413.16,493.6,413.09,493.59,412.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.65,473.52a4,4,0,0,1-2.5,3.34,35.57,35.57,0,0,1-26.71.2c-1.75-.66-3.76-2.78-3.92-4.64l-3.11-43.05c12.81,3.76,26.4,3.4,40.57,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.6,399.33H332.9a8.81,8.81,0,0,1-8.81-8.81h0a8.81,8.81,0,0,1,8.81-8.81h31.7Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,384.64H355.83v-2.93h70.49a1.47,1.47,0,0,1,1.46,1.47h0A1.47,1.47,0,0,1,426.32,384.64Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,399.33H355.83V396.4h70.49a1.47,1.47,0,0,1,1.46,1.47h0A1.47,1.47,0,0,1,426.32,399.33Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.63,396.4H363.86a5.88,5.88,0,0,1-5.88-5.88h0a5.88,5.88,0,0,1,5.88-5.88h61.77A14.59,14.59,0,0,0,425.63,396.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358,399.33H332.93a8.84,8.84,0,0,1-8.84-8.84h0a8.78,8.78,0,0,1,8.78-8.78h25.78C352.27,385.58,352.75,394.83,358,399.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M418.13,391.07c0,.06-12.68.1-28.32.1s-28.32,0-28.32-.1,12.68-.11,28.32-.11S418.13,391,418.13,391.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,393.68c0,.06-12.67.11-28.31.11s-28.32-.05-28.32-.11,12.68-.1,28.32-.1S424,393.62,424,393.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,387.36c0,.06-12.68.1-28.32.1s-28.32,0-28.32-.1,12.68-.11,28.32-.11S422.24,387.3,422.24,387.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.87,398.09c0,.06-5.93.11-13.25.11s-13.26-.05-13.26-.11,5.94-.1,13.26-.1S354.87,398,354.87,398.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.87,383.18c0,.05-5.93.1-13.25.1s-13.26,0-13.26-.1,5.94-.11,13.26-.11S354.87,383.12,354.87,383.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.45,434.38H320.62A11.35,11.35,0,0,1,309.27,423h0a11.35,11.35,0,0,1,11.35-11.34h40.83Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92,415.46H350.15v-3.77h90.77a1.89,1.89,0,0,1,1.89,1.88h0A1.89,1.89,0,0,1,440.92,415.46Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.92,434.38H350.15v-3.77h90.77a1.89,1.89,0,0,1,1.89,1.88h0A1.89,1.89,0,0,1,440.92,434.38Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,430.61H360.49a7.58,7.58,0,0,1-7.58-7.58h0a7.57,7.57,0,0,1,7.58-7.57H440A18.76,18.76,0,0,0,440,430.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.91,434.38H320.49a11.23,11.23,0,0,1-11.22-11.22h0a11.47,11.47,0,0,1,11.47-11.47h33C345.56,416.67,346.17,428.58,352.91,434.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M430.38,423.74c0,.06-16.33.1-36.47.1s-36.47,0-36.47-.1,16.32-.11,36.47-.11S430.38,423.68,430.38,423.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.88,427.11c0,.05-16.33.1-36.47.1s-36.47,0-36.47-.1,16.33-.11,36.47-.11S437.88,427.05,437.88,427.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.67,420.61c0,.06-16.33.11-36.47.11s-36.47-.05-36.47-.11,16.33-.1,36.47-.1S435.67,420.55,435.67,420.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.92,432.79s-7.65.1-17.07.1-17.08-.05-17.08-.1,7.65-.11,17.08-.11S348.92,432.73,348.92,432.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.92,413.57c0,.06-7.65.11-17.07.11s-17.08-.05-17.08-.11,7.65-.1,17.08-.1S348.92,413.52,348.92,413.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,411.77H339.1a6.48,6.48,0,0,1-6.49-6.49h0a6.48,6.48,0,0,1,6.49-6.49H375Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.57,401.85H365.81v-3.06h73.76a1.53,1.53,0,0,1,1.53,1.53h0A1.54,1.54,0,0,1,439.57,401.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.57,411.77H365.81v-3h73.76a1.53,1.53,0,0,1,1.53,1.52h0A1.53,1.53,0,0,1,439.57,411.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.85,408.72H371.49a3.44,3.44,0,0,1-3.43-3.44h0a3.43,3.43,0,0,1,3.43-3.43h67.36A5.2,5.2,0,0,0,438.85,408.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.06,411.77h-29a6.44,6.44,0,0,1-6.44-6.44h0a6.54,6.54,0,0,1,6.54-6.54h29.61C362.09,401.64,362.59,408.46,368.06,411.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M431,404.74c0,.06-13.27.11-29.63.11s-29.63-.05-29.63-.11,13.26-.11,29.63-.11S431,404.68,431,404.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.1,406.59c0,.06-13.27.1-29.63.1s-29.63,0-29.63-.1,13.26-.11,29.63-.11S437.1,406.53,437.1,406.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,410.48c0,.06-6.21.11-13.87.11s-13.87,0-13.87-.11,6.2-.1,13.87-.1S364.82,410.43,364.82,410.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,400.32c0,.05-6.21.1-13.87.1s-13.87-.05-13.87-.1,6.2-.11,13.87-.11S364.82,400.26,364.82,400.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.21,398.79c0,.06-22.78.1-50.87.1s-50.88,0-50.88-.1,22.77-.11,50.88-.11S440.21,398.73,440.21,398.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.16 387.43 384.16 394.49 386.61 392.92 389.33 394.49 389.33 387.43 384.16 387.43",
    style: {
      fill: "#FFBE0B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.19,207.25l10.94-2.12A34.15,34.15,0,1,0,663,197h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.19,207.25s0-.21.1-.65.18-1.11.32-2c.3-1.77.73-4.36,1.3-7.72a.1.1,0,0,1,.12-.09l.05,0h0l-.16.16a34.18,34.18,0,0,1-6.76-15.33,33.48,33.48,0,0,1-.47-5.3,37.47,37.47,0,0,1,.45-5.7A33.74,33.74,0,0,1,660.29,159a34.29,34.29,0,0,1,9.1-10.29,34,34,0,0,1,29.26-5.79,34.69,34.69,0,0,1,19.93,14.18l1.07,1.76.53.88.45.92c.29.62.59,1.23.88,1.84s.48,1.26.72,1.89a34.08,34.08,0,0,1-2.86,29.43A34.29,34.29,0,0,1,699,209.14a38,38,0,0,1-5.59,1.05,47.44,47.44,0,0,1-5.3.1,33.91,33.91,0,0,1-16-5.07l.08,0L664,206.76l-2.08.37-.69.12.73-.16,2.1-.43,8.09-1.64a.11.11,0,0,1,.08,0A34,34,0,0,0,688.11,210a46.81,46.81,0,0,0,5.25-.13,37.46,37.46,0,0,0,5.52-1.06,33.79,33.79,0,0,0,22.87-44.24c-.24-.62-.43-1.26-.71-1.87l-.87-1.8-.44-.91-.53-.86-1.05-1.74a34.59,34.59,0,0,0-5.36-6.19,32.34,32.34,0,0,0-14.27-7.78,33.83,33.83,0,0,0-42,27.38,38,38,0,0,0-.46,5.63,32.8,32.8,0,0,0,.44,5.25,34,34,0,0,0,6.6,15.25.11.11,0,0,1,0,.15.11.11,0,0,1-.14,0h0l.17-.06c-.61,3.31-1.09,5.87-1.41,7.62-.16.86-.29,1.52-.38,2S661.19,207.25,661.19,207.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.37,176.07a3.46,3.46,0,1,1-3.46-3.46A3.46,3.46,0,0,1,680.37,176.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.24,176.07a3.47,3.47,0,1,1-3.47-3.46A3.47,3.47,0,0,1,694.24,176.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.06,174.34a3.46,3.46,0,1,1-4.73-1.27A3.46,3.46,0,0,1,708.06,174.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.26,265.11l-10.34-.6a33.39,33.39,0,1,1,7.14-9.58h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.26,265.11l-.19-.64c-.13-.45-.33-1.1-.59-2-.53-1.74-1.31-4.3-2.33-7.63l0-.14-.1.11h0l.14.1a33.2,33.2,0,0,0,3-21.13,38,38,0,0,0-1.52-5.34,33,33,0,0,0-6.16-10.4A33.33,33.33,0,0,0,57,209.89,32.67,32.67,0,0,0,44.57,220c-.41.56-.83,1.1-1.22,1.67l-1.06,1.76-.52.88-.45.91L40.45,227c-.27.62-.47,1.27-.71,1.9a15.81,15.81,0,0,0-.63,1.91,31.14,31.14,0,0,0-.87,3.89,33.16,33.16,0,0,0,8.23,27.84,33.58,33.58,0,0,0,10.78,7.9,33.2,33.2,0,0,0,11.75,3,35.4,35.4,0,0,0,5.56-.07,41.25,41.25,0,0,0,5.1-.92A33.09,33.09,0,0,0,94,264.57l-.06,0,7.73.4,2,.1.65,0-.69-.05-2-.14-7.66-.5h0l0,0a33.24,33.24,0,0,1-14.26,7.77,45.29,45.29,0,0,1-5.07.89,36.06,36.06,0,0,1-5.51,0,33,33,0,0,1-11.63-3,33,33,0,0,1-18.75-35.37,28.47,28.47,0,0,1,.85-3.85,16.11,16.11,0,0,1,.63-1.89c.23-.62.43-1.26.7-1.87s.57-1.21.86-1.82l.44-.9.52-.87c.35-.58.7-1.16,1-1.74s.81-1.1,1.21-1.65a33.18,33.18,0,0,1,27-13.15,33.11,33.11,0,0,1,30.44,21.55,37.77,37.77,0,0,1,1.52,5.29,32.94,32.94,0,0,1,.58,5.1,33.34,33.34,0,0,1-3.41,15.9l-.27.56.41-.46h0l-.15,0c1.05,3.3,1.86,5.82,2.41,7.55q.42,1.27.63,1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.45,246.46H76.71a4,4,0,0,1-4.14,4,3.83,3.83,0,0,1-3.71-2.44,4.24,4.24,0,0,1,.33-3.84c.81-1.33,2.57-2.53,5.76-2V231.57H70.27v6.26a9.16,9.16,0,0,0-6.58,8.95c0,6.93,6.22,8.54,8.88,8.54C74.6,255.32,81.54,254.82,81.45,246.46Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.21,
    y: 224.93,
    width: 4.76,
    height: 4.44,
    transform: "translate(145.18 454.3) rotate(180)",
    style: {
      fill: "#FFBE0B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.65,175a8.94,8.94,0,0,1-4.31-17.25A9.3,9.3,0,0,1,568,141.8a11.12,11.12,0,0,1,16.49-9.61,12.51,12.51,0,0,1,15.38-.78,8.9,8.9,0,0,1,8.31,14.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,140.17l-2,.06a37.9,37.9,0,0,0-36.68,36c-.9,18.35-1.66,38.64-1.24,48.46.89,20.32,21.33,22.85,21.33,22.85l-1,24.48L631.83,269l1.59-88.74C634.58,159.06,623.22,140.74,602,140.17Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.31,247.53a49.3,49.3,0,0,0,26.4-8.63s-6.12,15.78-26.46,14.59Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.8,196.2a2.89,2.89,0,0,0,2.89,2.84,2.77,2.77,0,0,0,2.91-2.71,2.9,2.9,0,0,0-2.89-2.84A2.77,2.77,0,0,0,568.8,196.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.07,186.06c.37.37,2.52-1.33,5.65-1.42s5.46,1.41,5.79,1c.16-.17-.23-.84-1.25-1.54a8,8,0,0,0-4.65-1.28,7.66,7.66,0,0,0-4.48,1.61C568.19,185.2,567.89,185.9,568.07,186.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.85,196.2a2.9,2.9,0,0,0,2.9,2.84,2.77,2.77,0,0,0,2.91-2.71,2.91,2.91,0,0,0-2.89-2.84A2.79,2.79,0,0,0,595.85,196.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.81,185.68c.38.37,2.53-1.32,5.65-1.41s5.46,1.4,5.79,1c.16-.17-.22-.84-1.25-1.54a8,8,0,0,0-4.65-1.27,7.69,7.69,0,0,0-4.48,1.6C597.94,184.83,597.63,185.52,597.81,185.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.19,209.21c0-.18-1.94-.45-5.1-.75-.8-.06-1.56-.2-1.71-.74a4.07,4.07,0,0,1,.45-2.38c.69-2,1.42-4,2.17-6.15,3-8.75,5.16-15.94,4.8-16.06s-3.07,6.88-6.08,15.64c-.72,2.16-1.41,4.21-2.07,6.18a4.62,4.62,0,0,0-.31,3.15,2,2,0,0,0,1.35,1.12,5.32,5.32,0,0,0,1.36.15C586.22,209.44,588.18,209.39,588.19,209.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.72,173.75c.44.78,3.09-.17,6.38-.38s6.09.25,6.36-.58c.12-.4-.49-1.09-1.7-1.69a9.92,9.92,0,0,0-5-.88,9.59,9.59,0,0,0-4.72,1.61C596,172.6,595.52,173.37,595.72,173.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.52,173.18c.68.69,3.23-.13,6.33-.26s5.75.3,6.33-.46c.25-.37-.18-1.07-1.35-1.7a10.74,10.74,0,0,0-10.2.58C567.55,172.1,567.22,172.85,567.52,173.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.05,166.87s5-12.91,11-16.07c7.32-3.83,10.77,4.23,17.79,2s14-5.88,21.42-.63c8.12,5.75,4.54,10.07,5.31,19.07,3.13,36.52,10.13,46.65,11.49,29.37.15-1.9,5.34-3.56,5.87-11.56.68-10.38.69-22.94-1.85-30.21-2.14-6.13-5.8-10.29-12.27-14.8-10.22-7.13-23.94-6.86-33.22-5.63S563.71,151,565.05,166.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.77,200.12a5.51,5.51,0,0,1,5.79-5.5c3.8.24,8.09,2.26,8.09,10.1,0,13.92-14,11-14,10.64S630.71,206,630.77,200.12Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.68,210.13c.06,0,.24.17.65.36a2.4,2.4,0,0,0,1.81,0c1.47-.53,2.71-2.87,2.78-5.38a7.94,7.94,0,0,0-.68-3.47,2.8,2.8,0,0,0-1.82-1.86,1.22,1.22,0,0,0-1.43.67c-.19.38-.1.66-.17.69s-.3-.24-.19-.81a1.51,1.51,0,0,1,.55-.87,1.87,1.87,0,0,1,1.34-.36,3.43,3.43,0,0,1,2.53,2.16,8.26,8.26,0,0,1,.84,3.88c-.09,2.81-1.53,5.43-3.54,6a2.61,2.61,0,0,1-2.22-.37C633.7,210.46,633.63,210.15,633.68,210.13Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.65,173.2c-1.76,1.29-3.63,2.62-5.8,2.9s-4.69-.89-5.13-3c-.19-1,0-2.09-.65-2.82s-2.18-.55-3.34-.39c-4,.56-8.89-3.76-10.05-7.66a3.61,3.61,0,0,1-4.81,1.16,13.2,13.2,0,0,1-3.45-2.87c-1.26-1.36-3-2.56-4.84-2.24-1,.18-2,.82-3,.76-1.84-.11-2.79-2.22-3.13-4s-.61-3.91-2.19-4.85-3.3-.28-5,0-3.86,0-4.34-1.65a3.32,3.32,0,0,1,.54-2.54A9,9,0,0,1,585,142.22a12.2,12.2,0,0,1,22.34-3.06,12.39,12.39,0,0,1,19.94,3.89,9,9,0,0,1,10.53,12.74c2.54,1.35,4.76,3.77,4.9,6.64s-2.57,5.83-5.37,5.16a5,5,0,0,1-8.44,5.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.11,146.35a.67.67,0,0,0,0,.25c0,.17,0,.42.11.74a8.81,8.81,0,0,0,1.1,2.65,10,10,0,0,0,3.18,3.19,9.22,9.22,0,0,0,5.75,1.44l-.25-.3a5.06,5.06,0,0,0,.4,3.83,14.44,14.44,0,0,0,2.49,3.35,10.24,10.24,0,0,0,1.6,1.54,4.78,4.78,0,0,0,2.23.75,5.1,5.1,0,0,0,4.43-1.74l-.53-.13a10.43,10.43,0,0,0,4.65,7.07,7.58,7.58,0,0,0,4.61,1.36,13.93,13.93,0,0,0,4.47-1.13l-.38-.16a10.89,10.89,0,0,0,3.43,4.19,5.79,5.79,0,0,0,4.88,1.17,7.66,7.66,0,0,0,5.71-6.18l-.31.16a7.12,7.12,0,0,0,4.8.55,7.74,7.74,0,0,0,3.28-1.59,6.61,6.61,0,0,0,1.5-1.75,2.71,2.71,0,0,0,.33-.73,8.17,8.17,0,0,1-2,2.3,7.84,7.84,0,0,1-3.21,1.44,6.83,6.83,0,0,1-4.53-.6l-.27-.14,0,.3a7.24,7.24,0,0,1-5.41,5.73,5.34,5.34,0,0,1-4.43-1.11,10.43,10.43,0,0,1-3.22-4l-.12-.25-.26.1a13.08,13.08,0,0,1-4.27,1.07,7,7,0,0,1-4.26-1.26,9.87,9.87,0,0,1-4.4-6.66l-.1-.66-.42.52a4.49,4.49,0,0,1-3.91,1.54,4.29,4.29,0,0,1-2-.64,10.85,10.85,0,0,1-1.52-1.45,14.28,14.28,0,0,1-2.42-3.2,4.6,4.6,0,0,1-.42-3.47l.11-.33-.35,0a8.88,8.88,0,0,1-5.5-1.3,9.78,9.78,0,0,1-3.16-3A10.69,10.69,0,0,1,584.11,146.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.94,213a66.63,66.63,0,0,1-9.45,4c0,2.41,3.06,5.82,5.47,5.89a5.61,5.61,0,0,0,5.59-3c.87-1.83.41-4.23-.2-6.32A1,1,0,0,0,596.94,213Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.63,222.18s.37.17,1,.37a5.53,5.53,0,0,0,2.93,0,5.81,5.81,0,0,0,3.44-2.49,4.84,4.84,0,0,0,.77-2.39,10.25,10.25,0,0,0-.33-2.76c-.11-.47-.24-1-.36-1.39,0-.2-.2-.45-.2-.4a.86.86,0,0,0-.52.08l-2.47,1-4.19,1.68L587.9,217a5.32,5.32,0,0,1-1.07.33,4.77,4.77,0,0,1,1-.52l2.79-1.24,4.15-1.79,2.46-1a1.3,1.3,0,0,1,.85-.11.64.64,0,0,1,.4.37,2.21,2.21,0,0,1,.15.37c.14.49.26.94.37,1.43a10.3,10.3,0,0,1,.34,2.91,5.28,5.28,0,0,1-.88,2.62,6.06,6.06,0,0,1-3.75,2.59,5.42,5.42,0,0,1-3.09-.15,3.7,3.7,0,0,1-.75-.37C590.7,222.26,590.62,222.2,590.63,222.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679,297.11s14.79,84,14.08,91.88-4.65,20.35-13.57,22.5a39.32,39.32,0,0,1-17.14,0l10.71-103.21Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679,297.11c0-8-12.58-20.75-21.7-27.05-4.43-3.07-23-16.31-23-16.31l-1.71-4.64c-17,4.19-34.56,4.59-51.25,3.58l-1.52,4.56-20.65,6L540.72,337l.54,97.81,124.27-.32,1-8.93S679,302.68,679,297.11Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M668.21,411.73c10.93-25.62,10.08-54.58,8.59-82.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M679,311.75c.14,0-2.64,26.42-6.22,59s-6.6,58.92-6.74,58.91,2.64-26.41,6.22-59S678.9,311.74,679,311.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.13,429.35c-.14,0,.09-15.17.51-33.87s.89-33.86,1-33.85-.09,15.16-.52,33.87S565.28,429.35,565.13,429.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.39,253.75a1.89,1.89,0,0,1-.52.21l-1.52.49c-.66.22-1.48.47-2.44.71s-2,.56-3.26.82c-2.43.58-5.35,1.09-8.61,1.58s-6.88.8-10.68,1a147.5,147.5,0,0,1-19.45-.35c-2.48-.21-4.49-.43-5.87-.62l-1.58-.23a2.21,2.21,0,0,1-.55-.11,1.83,1.83,0,0,1,.56,0l1.59.13c1.39.13,3.4.29,5.87.45a171.15,171.15,0,0,0,19.41.2c3.78-.2,7.38-.54,10.63-1s6.17-.93,8.6-1.46c1.22-.24,2.31-.51,3.27-.74s1.78-.43,2.45-.62l1.55-.4A2.12,2.12,0,0,1,634.39,253.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.6,238.46,459,249.16a10.54,10.54,0,0,0,3.39,1.68,3.2,3.2,0,0,0,3.61-5,10.52,10.52,0,0,0-3-3l-18.48-14.14a14.88,14.88,0,0,0-5-2.89,5,5,0,0,0-5.31,1.45,4.06,4.06,0,0,0,.34,5.33c1.4,1.5,6.32,4.74,8.08,5.86",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.6,316.43l1.21-.22L455.08,273,459,260.54s4.53-17.74.76-22.27c0,0-8.26-9.72-10.94-9.59s-4.82.67-5.36,2.68c0,0-4.55-.54-5.76.94a23.49,23.49,0,0,0-2.14,3.21s-4.95-.4-6.29,3.89c0,0-4.69,2.41-5.09,5.89s.94,19.69,2.41,23.84,7,12.86,8.57,25.71,7.27,21.21,12.31,40l13.67,5.4Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.69,231.09a24.54,24.54,0,0,1,2.88,3.34,24.21,24.21,0,0,1,1.76,4,8.36,8.36,0,0,0-4.64-7.39Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.82,235.51a25.82,25.82,0,0,1,2.82,3,27.22,27.22,0,0,1,1.86,3.66,7.75,7.75,0,0,0-4.68-6.65Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.52,239.26c-.1.13,1.13,1.21,2.26,2.84s1.73,3.15,1.88,3.09a8.69,8.69,0,0,0-4.14-5.93Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.73,240.68a9.9,9.9,0,0,1,2.75-.47,9.38,9.38,0,0,1,2.65.84c.05-.05-.13-.35-.58-.68a3.89,3.89,0,0,0-2-.72,4.06,4.06,0,0,0-2.12.43C452.91,240.35,452.69,240.63,452.73,240.68Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.88,246.85a10.86,10.86,0,0,1,2-2.45,11.4,11.4,0,0,1,2.89-1.32c0-.07-.38-.16-1-.08a4.83,4.83,0,0,0-2.23,1,4.76,4.76,0,0,0-1.51,1.9C442.83,246.44,442.81,246.83,442.88,246.85Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.09,248.94a11.74,11.74,0,0,1,3-1.58,12.25,12.25,0,0,1,3.42-.17c0-.07-.33-.29-1-.45a5.49,5.49,0,0,0-4.86,1.32C433.22,248.52,433,248.89,433.09,248.94Z",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.29,260.87s-12.9,2.16-14,2.42c-3.94.91-14.61,8.09-26.92,20.3-11.75,11.65-34.86,35.88-34.86,35.88s-4.15-4.19-8.89,1.41L457,274.58l-25.73,9.88,2.44,10.28c-7.11,12.58,15.63,43.44,20.23,51.11,0,0,25.45,42.24,45.56,34.59,18.36-7,40.84-25,45.13-28.73l26.53-20.22s18.52-35.31,10.33-53Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.45,368.81a2.14,2.14,0,0,0,.54-.32l1.48-1c1.29-.86,3.13-2.14,5.4-3.73,4.54-3.19,10.75-7.66,17.53-12.71s12.84-9.74,17.19-13.18c2.17-1.72,3.92-3.13,5.12-4.11l1.37-1.14a3.18,3.18,0,0,0,.46-.42,3.5,3.5,0,0,0-.52.35l-1.43,1.07-5.21,4c-4.39,3.37-10.48,8-17.26,13.06s-13,9.57-17.44,12.82l-5.31,3.85-1.44,1.07A3.3,3.3,0,0,0,521.45,368.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.12,341.11c.08,0,0-1.36.19-3.54a38.19,38.19,0,0,1,1.58-8.38,38.92,38.92,0,0,1,3.44-7.79c1.11-1.89,1.93-3,1.86-3a3.8,3.8,0,0,0-.64.72,23.64,23.64,0,0,0-1.5,2.14A32.94,32.94,0,0,0,491,337.55a21.1,21.1,0,0,0,0,2.61A3.82,3.82,0,0,0,491.12,341.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.53,339.07c.08,0-.1-1.07-.23-2.78a36.54,36.54,0,0,1,.12-6.68,36.12,36.12,0,0,1,1.41-6.54c.51-1.64.92-2.63.85-2.66a2.51,2.51,0,0,0-.38.66c-.21.43-.49,1.08-.79,1.89A29.19,29.19,0,0,0,485,336.32c.11.86.23,1.56.34,2A2.3,2.3,0,0,0,485.53,339.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.52,321.82s.46-.74,1.26-2.07a32.26,32.26,0,0,0,2.76-6,32.83,32.83,0,0,0,1.78-9.56,30.59,30.59,0,0,0-7.85-21.9,32.89,32.89,0,0,0-13.38-9.11c-1.47-.52-2.3-.75-2.29-.8a2.42,2.42,0,0,1,.62.12,18,18,0,0,1,1.74.49,30.12,30.12,0,0,1,6.05,2.73,32.2,32.2,0,0,1,7.61,6.25,30.53,30.53,0,0,1,8,22.24,32.1,32.1,0,0,1-1.91,9.66,29.57,29.57,0,0,1-2.94,6c-.4.68-.8,1.14-1,1.48A2.78,2.78,0,0,1,577.52,321.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M540.55,355l.06,0-.29,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M574.3,329.16s-22.68,17.7-33.69,25.84C555.09,353.18,568.14,342.4,574.3,329.16Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-117"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.48 433.67 179.94 467.22 263.41 460.11 187.19 432.09 101.48 433.67",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.07 460.11 176.79 453.78 257.76 449.28 257.76 454.51 177.07 460.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.75,452.25c0,.15-16.65,1.4-37.2,2.79s-37.23,2.41-37.24,2.27,16.64-1.39,37.2-2.79S251.74,452.11,251.75,452.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.92 454.51 125.46 434.12 125.36 437.96 177.07 460 176.92 454.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.46 434.12 176.92 454.51 257.76 449.28 196.48 431.42 125.46 434.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46,434.11l71-2.92h.07L257.84,449a.26.26,0,0,1,.17.32.26.26,0,0,1-.23.19l-.72,0-80.12,5.14-.1,0-51.38-20.59L177,454.31h-.09L257,449.06l.73,0-.06.51-61.27-17.9h.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.07,460.11a15.21,15.21,0,0,1,0-5.6,15.21,15.21,0,0,1,0,5.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.22,445.47c0,.14-12.39,1-27.7,1.88s-27.73,1.51-27.74,1.37,12.4-1,27.71-1.89S232.21,445.32,232.22,445.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,443.25c0,.14-12.39,1-27.7,1.89S170,446.65,170,446.51s12.4-1,27.71-1.89S225.42,443.11,225.42,443.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63,441c0,.14-12.4,1-27.71,1.88s-27.73,1.51-27.74,1.37,12.4-1,27.71-1.89S218.62,440.89,218.63,441Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.83,438.82c0,.14-12.4,1-27.71,1.89s-27.72,1.51-27.73,1.36,12.39-1,27.7-1.88S211.82,438.68,211.83,438.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,436.6c0,.15-12.4,1-27.7,1.89s-27.73,1.51-27.74,1.37,12.39-1,27.71-1.89S205,436.46,205,436.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.23,434.39c0,.14-12.39,1-27.7,1.89s-27.73,1.51-27.74,1.36,12.39-1,27.71-1.88S198.22,434.25,198.23,434.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2,356.7s-32.52-28.43-36.69-32.32c-16.35-15.31-28.49-16-28.49-16l-14.72-3.19L149.22,299l-36.53,5.71-12,51.48-.86,25.94-4.18,48.71H222.35l-.7-10.8L225,372.8l-.45,9.15,15.69,13.47Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.34,350.57a3.54,3.54,0,0,1,0,.53c0,.4,0,.91-.06,1.54-.08,1.39-.19,3.31-.32,5.66-.31,4.82-.73,11.39-1.2,18.65s-1,13.82-1.32,18.64c-.19,2.35-.34,4.26-.45,5.65-.06.63-.11,1.14-.14,1.53a3.23,3.23,0,0,1-.08.53,2,2,0,0,1,0-.54c0-.39,0-.9.07-1.54.07-1.38.18-3.3.31-5.65.31-4.82.74-11.39,1.2-18.65s1-13.82,1.33-18.64c.18-2.34.34-4.26.45-5.64,0-.64.1-1.15.14-1.54A2.26,2.26,0,0,1,226.34,350.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.7,345.82c0,.62-2.11,32-2.15,32.59C229.86,368.07,231.58,356.37,226.7,345.82Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.61,396.49c9-7.62,10-19.25,9-31L99.9,381Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M49,368.21c.71,0,42.91,26.84,42.91,26.84l29.35-45.51-8.54-44.79s-17.44,2.64-25.07,11C82.91,320.9,49,368.21,49,368.21Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4,345.11a16.31,16.31,0,0,1,.44-1.72,37.87,37.87,0,0,0,.9-4.74,33.71,33.71,0,0,0,.13-7.13,21.78,21.78,0,0,0-2.32-8.32,23.83,23.83,0,0,0-5.52-6.67,26.09,26.09,0,0,0-6-3.79,35.11,35.11,0,0,0-6.28-2,1.78,1.78,0,0,1,.46,0c.3,0,.75.07,1.31.19a23.07,23.07,0,0,1,4.66,1.42,25,25,0,0,1,6.17,3.75A23.67,23.67,0,0,1,119,323a21.79,21.79,0,0,1,2.34,8.53,32,32,0,0,1-.25,7.22,29.28,29.28,0,0,1-1.07,4.75,10.73,10.73,0,0,1-.44,1.24C119.48,345,119.42,345.12,119.4,345.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08,198.33l-1.87-.09c-20.25.13-31.46,17.4-30.76,37.64l1.77,67,1.49,2.31A43.67,43.67,0,0,0,166,321.93h0a16.55,16.55,0,0,0,22.72-15.43h0s0-5.35.06-5.35,19.57-2,20.81-21.4c.61-9.37.28-28.76-.22-46.31A36.21,36.21,0,0,0,175.08,198.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.86,301.12s-12.27.08-24.88-8.78c0,0,5.32,14.9,24.77,14.16Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.55,249.18a2.76,2.76,0,0,1-2.81,2.65,2.65,2.65,0,0,1-2.73-2.64,2.77,2.77,0,0,1,2.81-2.66A2.64,2.64,0,0,1,203.55,249.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,240.87c-.36.35-2.38-1.32-5.36-1.46s-5.24,1.23-5.55.85c-.15-.17.23-.81,1.22-1.45a7.61,7.61,0,0,1,4.47-1.13,7.28,7.28,0,0,1,4.24,1.62C204.73,240.05,205,240.72,204.83,240.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,248.41a2.77,2.77,0,0,1-2.82,2.65,2.64,2.64,0,0,1-2.72-2.64,2.76,2.76,0,0,1,2.81-2.66A2.65,2.65,0,0,1,176,248.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,240.05c-.37.34-2.39-1.32-5.37-1.47s-5.24,1.23-5.55.85c-.15-.17.23-.8,1.23-1.45a7.63,7.63,0,0,1,4.46-1.13,7.41,7.41,0,0,1,4.25,1.62C175.47,239.22,175.74,239.89,175.57,240.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.07,263.52c0-.17,1.87-.4,4.89-.63.77,0,1.5-.15,1.65-.66a3.91,3.91,0,0,0-.39-2.29L189.27,254c-2.7-8.42-4.61-15.32-4.27-15.43s2.8,6.63,5.5,15.05l1.86,5.94a4.48,4.48,0,0,1,.24,3,1.92,1.92,0,0,1-1.31,1,5.25,5.25,0,0,1-1.31.11C187,263.77,185.08,263.69,185.07,263.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,230.77c-.45.74-3.3-.21-6.82-.47s-6.48.13-6.8-.67c-.14-.38.49-1,1.77-1.59a11.89,11.89,0,0,1,10.37.87C176.7,229.66,177.22,230.41,177,230.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,232.11c-.65.66-3.05-.14-6-.28s-5.42.26-6-.47c-.24-.35.18-1,1.28-1.62a9.38,9.38,0,0,1,4.9-.93,9.21,9.21,0,0,1,4.71,1.54C205.4,231.08,205.71,231.79,205.43,232.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.29,249.4c-.32-.16-13.12-4.63-13.39,8.65S144,269.15,144,268.77,143.29,249.4,143.29,249.4Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.1,263.37s-.23.16-.63.33a2.26,2.26,0,0,1-1.73,0c-1.39-.54-2.53-2.79-2.54-5.19a7.58,7.58,0,0,1,.71-3.3,2.65,2.65,0,0,1,1.78-1.74,1.18,1.18,0,0,1,1.35.66c.17.37.08.64.15.66s.29-.22.19-.77a1.51,1.51,0,0,0-.5-.84,1.72,1.72,0,0,0-1.28-.36,3.24,3.24,0,0,0-2.45,2,7.86,7.86,0,0,0-.88,3.69c0,2.68,1.35,5.21,3.26,5.8a2.49,2.49,0,0,0,2.13-.31C139.07,263.69,139.15,263.4,139.1,263.37Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.68,265.26c.46,0,.45,3,3,5.21s5.85,1.87,5.87,2.3c0,.19-.73.59-2.1.61a7.55,7.55,0,0,1-4.9-1.74,6.62,6.62,0,0,1-2.36-4.36C175.13,266,175.48,265.24,175.68,265.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.41,215.32a3.17,3.17,0,0,0-1.43-1.88c-1.51-.93-3.26-.85-5-.91a28,28,0,0,1-12.09-3.32,14,14,0,0,0,3.63-2.43c2.2-2.1,3.5-5.35,2.58-8.24a1.84,1.84,0,0,0-1-1.3c-.86-.28-1.63.55-2.25,1.21-2,2.17-3.88,3.08-6.82,2.71a11.7,11.7,0,0,1-5-1.6c-.06-.06-.11-.13-.16-.19-.68-.73-1.34-1.42-2-2.1h0c-4.89-5.07-9.11-8.6-13.5-10.48-6.43-2.75-17.26-4-24.06-2.42s-13,7-14.09,13.89c-3.73-3.29-9.42-3.39-14.08-1.63l-.12-.06c-5.18,1.72-8.23,7.1-9.86,12.31-.09.29-.17.57-.25.86a20.44,20.44,0,0,1-7.07,6.61c-.51.28-1.09.62-1.16,1.19a1.67,1.67,0,0,0,.85,1.39,10.32,10.32,0,0,0,4.13,1.83,23.35,23.35,0,0,1-1.79,3.57c-.6,1-1.31,2.14-.83,3.17a2.17,2.17,0,0,0,2.25,1,6.32,6.32,0,0,0,2.42-1l-1.81,4.08a12.06,12.06,0,0,0,5.6-.25c1,4.93,1.61,14,2.8,17.39,3.53.14,4.39-.22,6.16.41,2.28.81,1.32,4.87,4.34,3.77,1.53-.55,4-6.28,4.54-7.82a75.84,75.84,0,0,0,4-32,24.29,24.29,0,0,1,7.65-5.27l-.23.2c5.47-1.77,11.66-3.49,16.76-.83,4,2.07,6.21,6.27,9.13,9.65,5.53,6.4,11.87,9.89,20.31,10.43.63,5.89.65,15.49.81,21l4.92-10.86v0c.39-.64.72-1.28,1-1.92l.11-.19v0a33.61,33.61,0,0,1,1.61-3.08l.05.05c2.91,2.68,7.37-1.22,5.1-4.46a7.47,7.47,0,0,0-1.62-1.7,5.45,5.45,0,0,0,5.13,1.45,4.24,4.24,0,0,0,3.09-4.14,3.61,3.61,0,0,0-2.09-2.94,12.12,12.12,0,0,0,7-1.38C235.47,218.3,236.84,217.05,236.41,215.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.41,215.32a1.91,1.91,0,0,1,.1.76,3,3,0,0,1-1,2,9,9,0,0,1-3.27,1.83,12.4,12.4,0,0,1-5.12.59l0-.17a3.81,3.81,0,0,1,2,2.4,3.88,3.88,0,0,1-.86,3.41,4.47,4.47,0,0,1-3.52,1.64,5.81,5.81,0,0,1-3.93-1.65l.17-.2a7.1,7.1,0,0,1,1.9,2.16,3.55,3.55,0,0,1,.4,1.48,3.41,3.41,0,0,1-.36,1.53,3.88,3.88,0,0,1-2.46,2,3.38,3.38,0,0,1-3.19-.86l.23,0L216,235.32v0l0,0-1.14,2.12-.27.5,0-.57v-.05l.31.06L210,248.27l-.32.71,0-.78c-.21-6.41-.13-13.5-.83-20.94l.19.18a27.87,27.87,0,0,1-12-3.42,33.3,33.3,0,0,1-9.86-8.82,57.32,57.32,0,0,0-4.31-5.3,12.11,12.11,0,0,0-5.85-3.48,17,17,0,0,0-7-.07,50.47,50.47,0,0,0-7,1.86l-1.14.37.91-.79.24-.2.25.41a24.38,24.38,0,0,0-7.57,5.22l.07-.2a76.55,76.55,0,0,1-2.19,26.28c-.59,2.21-1.26,4.39-2.07,6.58a30.34,30.34,0,0,1-3.23,6.21c-.59,1-2.25,1.84-3.37.77a5.58,5.58,0,0,1-.86-1.63,4.27,4.27,0,0,0-.83-1.43,3.5,3.5,0,0,0-.3-.24l-.35-.17a7.53,7.53,0,0,0-.81-.24,8,8,0,0,0-1.71-.14c-1.17,0-2.38,0-3.57,0h-.18l0-.17a33.65,33.65,0,0,1-1.13-5.48c-.59-4-.95-8-1.68-12l.32.2a12.44,12.44,0,0,1-5.72.26l-.32-.06.13-.3,1.81-4.09.37.33a5.37,5.37,0,0,1-3.12,1.08,2.5,2.5,0,0,1-1.59-.73,2,2,0,0,1-.47-1.69,9.92,9.92,0,0,1,1.42-2.92,24.11,24.11,0,0,0,1.34-2.81l.19.35a10.67,10.67,0,0,1-4.19-1.84,2.88,2.88,0,0,1-.84-.89,1.22,1.22,0,0,1,.07-1.32,2.77,2.77,0,0,1,.94-.76c.33-.19.64-.36,1-.56a20.29,20.29,0,0,0,6.16-6l0,.07a27.46,27.46,0,0,1,3.6-8,13.46,13.46,0,0,1,6.67-5.34l.1,0,.08,0,.12.05h-.19a17.37,17.37,0,0,1,7.49-1.09,11.77,11.77,0,0,1,6.83,2.77l-.39.14a15.84,15.84,0,0,1,3.9-7.93,20.08,20.08,0,0,1,7-5,22.88,22.88,0,0,1,8.14-1.78,45.49,45.49,0,0,1,8,.29,49.23,49.23,0,0,1,7.59,1.48,27.17,27.17,0,0,1,6.83,2.9,56.09,56.09,0,0,1,10.53,9l-.29.2h0l.31-.17h0l0,0c.78.84,1.48,1.55,2.15,2.29l0,0a10.78,10.78,0,0,0,4.21,1.48,7.9,7.9,0,0,0,4.22-.21,8.83,8.83,0,0,0,3.28-2.41,3.6,3.6,0,0,1,1.68-1.2,1.26,1.26,0,0,1,1,.25,2.14,2.14,0,0,1,.59.85,6.86,6.86,0,0,1,.27,3.79,9.42,9.42,0,0,1-1.42,3.3,12.22,12.22,0,0,1-5,4.05v-.2a28.55,28.55,0,0,0,8.13,2.89,25.48,25.48,0,0,0,3.43.43c1,.07,2,0,2.85.15a5,5,0,0,1,3.45,1.57,2.9,2.9,0,0,1,.49.85,1.6,1.6,0,0,1,.08.32,2.82,2.82,0,0,0-.62-1.13,4.9,4.9,0,0,0-3.41-1.49c-.84-.09-1.8-.07-2.85-.12a27.24,27.24,0,0,1-3.45-.41,28.47,28.47,0,0,1-8.2-2.86l-.2-.11.2-.09a12.06,12.06,0,0,0,4.91-4,8.75,8.75,0,0,0,1.37-3.2,6.64,6.64,0,0,0-.26-3.63,1.23,1.23,0,0,0-1.32-.92,3.37,3.37,0,0,0-1.52,1.12,9.25,9.25,0,0,1-3.38,2.5,8.3,8.3,0,0,1-4.4.24,11.23,11.23,0,0,1-4.34-1.52h0c-.66-.74-1.36-1.45-2.15-2.28l0-.05h0l.31-.17h0l.53,1-.82-.84a55,55,0,0,0-10.47-8.87,26.8,26.8,0,0,0-6.74-2.85,49.4,49.4,0,0,0-7.53-1.46,46.71,46.71,0,0,0-8-.27,22.51,22.51,0,0,0-8,1.76,19.66,19.66,0,0,0-6.83,4.89,15.41,15.41,0,0,0-3.78,7.71l-.07.42-.32-.28a11.21,11.21,0,0,0-6.56-2.65,16.9,16.9,0,0,0-7.28,1.06l-.09,0-.1,0-.11-.06.18,0A12.86,12.86,0,0,0,134.7,202a26.74,26.74,0,0,0-3.53,7.84v0l0,0a20.82,20.82,0,0,1-6.31,6.19,7.84,7.84,0,0,0-1.75,1.18c-.37.49.09,1.11.67,1.51a10,10,0,0,0,4,1.74l.3.06-.11.29a26.14,26.14,0,0,1-1.37,2.88,9.59,9.59,0,0,0-1.36,2.74,1.49,1.49,0,0,0,.33,1.26,2,2,0,0,0,1.26.56,5,5,0,0,0,2.82-1l.7-.43-.33.75c-.61,1.36-1.21,2.72-1.82,4.09l-.18-.36a12,12,0,0,0,5.48-.25l.28-.07.05.27c.74,4,1.1,8,1.69,12a33.23,33.23,0,0,0,1.1,5.38l-.24-.18c1.18.05,2.36,0,3.55,0a8.71,8.71,0,0,1,1.82.15,8.89,8.89,0,0,1,.88.26l.45.22a3.93,3.93,0,0,1,.38.31c.93.95,1,2.29,1.71,3.07a1.28,1.28,0,0,0,1.37.24,2.3,2.3,0,0,0,1.21-1,29.81,29.81,0,0,0,3.16-6.09c.8-2.13,1.47-4.33,2.06-6.51a76.51,76.51,0,0,0,2.19-26.1V213l.08-.08a24.63,24.63,0,0,1,7.73-5.32l1.47-.64L163.16,208l-.23.2-.24-.41a51.36,51.36,0,0,1,7.11-1.87A17.38,17.38,0,0,1,177,206a12.53,12.53,0,0,1,6.07,3.61,59.76,59.76,0,0,1,4.34,5.35,32.91,32.91,0,0,0,9.71,8.72A27.41,27.41,0,0,0,209,227h.18v.17c.7,7.49.6,14.57.8,21l-.35-.07,4.93-10.85.28-.6,0,.66v0l-.3-.08,1.14-2.1,0,.07v-.06l0,0,1.62-3.09.09-.17.15.14a3.08,3.08,0,0,0,2.9.8,3.58,3.58,0,0,0,2.28-1.87,3,3,0,0,0,.34-1.4,3.12,3.12,0,0,0-.36-1.35,6.66,6.66,0,0,0-1.82-2.08l.17-.19a5.54,5.54,0,0,0,3.75,1.59,4.26,4.26,0,0,0,3.35-1.54,3.68,3.68,0,0,0,.84-3.22,3.63,3.63,0,0,0-1.93-2.29l-.46-.22.5.05a12.22,12.22,0,0,0,5.07-.54,8.82,8.82,0,0,0,3.25-1.77,2.89,2.89,0,0,0,1-1.95A3.35,3.35,0,0,0,236.41,215.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.31,200.63a15.82,15.82,0,0,0-2,1.74,13.85,13.85,0,0,0-3.13,6.39,23.84,23.84,0,0,0-.6,4.93c-.05,1.79,0,3.71.14,5.74a50.22,50.22,0,0,1,0,6.38,23.22,23.22,0,0,1-.51,3.35,7,7,0,0,1-1.45,3.23,2.91,2.91,0,0,1-2.76.87,4.41,4.41,0,0,1-2.44-1.45,10.15,10.15,0,0,1-1.77-5l.41.06a16.56,16.56,0,0,1-2.45,4,5.87,5.87,0,0,1-3.83,2,3.68,3.68,0,0,1-2-.4,3.19,3.19,0,0,1-1.33-1.37,3.34,3.34,0,0,1-.38-1.73,2.41,2.41,0,0,1,.66-1.5l.2.19a12.54,12.54,0,0,1-4.25,3,11.55,11.55,0,0,1-1.3.48,2.17,2.17,0,0,1-.47.1l.45-.18c.29-.11.72-.27,1.26-.53a12.89,12.89,0,0,0,4.11-3.1l.2.19a2.5,2.5,0,0,0-.2,2.89,2.94,2.94,0,0,0,1.21,1.21,3.34,3.34,0,0,0,1.81.34,5.44,5.44,0,0,0,3.56-1.88,15.9,15.9,0,0,0,2.36-3.94l.3-.61.11.67a9.76,9.76,0,0,0,1.68,4.77,3.92,3.92,0,0,0,2.18,1.29,2.48,2.48,0,0,0,2.35-.73,6.63,6.63,0,0,0,1.34-3,23.62,23.62,0,0,0,.51-3.29,51.45,51.45,0,0,0,0-6.33c-.08-2-.17-3.95-.1-5.76a23.7,23.7,0,0,1,.67-5,13.77,13.77,0,0,1,3.31-6.43A7.77,7.77,0,0,1,161.31,200.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.05,220.87s0,0-.15.13l-.5.34a5.28,5.28,0,0,1-.83.51,10.29,10.29,0,0,1-1.2.6,17.18,17.18,0,0,1-8.36,1.31,22,22,0,0,1-11.64-4.59,38.35,38.35,0,0,1-9.83-11.84c-1.36-2.39-2.46-4.83-3.68-7.08a25.68,25.68,0,0,0-4.22-6,13.26,13.26,0,0,0-5.53-3.52,9.49,9.49,0,0,0-2.94-.41,10.32,10.32,0,0,0-2.72.46,11.26,11.26,0,0,0-6.37,5.15,13.37,13.37,0,0,0-1.06,2.9s0-.07,0-.21.06-.35.1-.59a9.9,9.9,0,0,1,.79-2.18,10.89,10.89,0,0,1,2.24-2.91,11.61,11.61,0,0,1,4.18-2.47,10.94,10.94,0,0,1,2.8-.5,9.89,9.89,0,0,1,3.07.39,13.64,13.64,0,0,1,5.72,3.6,25.94,25.94,0,0,1,4.31,6.09c1.24,2.28,2.34,4.71,3.69,7.07a38.1,38.1,0,0,0,9.68,11.74,21.92,21.92,0,0,0,11.42,4.6,17.5,17.5,0,0,0,8.26-1.15A29.14,29.14,0,0,0,221.05,220.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,212.36s-.23.2-.71.47a14.56,14.56,0,0,1-2.08,1,20.74,20.74,0,0,1-3.3,1,22.48,22.48,0,0,1-4.19.46,22,22,0,0,1-4.2-.38,20.43,20.43,0,0,1-3.32-.93,16.72,16.72,0,0,1-2.11-1c-.47-.27-.73-.43-.71-.46s1.1.5,2.93,1.11a22.29,22.29,0,0,0,3.28.83,25.16,25.16,0,0,0,4.12.34,25.84,25.84,0,0,0,4.12-.42,23.75,23.75,0,0,0,3.26-.89C221.92,212.88,223,212.29,223,212.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,411.51l27.34-1.32s5.31,3,6.69,11.7,0,8.67,0,8.67l-13.77,4.65-29.22-.68L161,421.23l8-4.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.89,394.91C295.44,392.39,286.7,382.1,266,361l-24.72,33.11,6.93,4.55-45.48,12.85,3.8,22.19,75.39-.07C291.63,433.31,309.54,416.86,296.89,394.91Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07,393.35a12.12,12.12,0,0,1-1.75,0c-1.13,0-2.75,0-4.76,0a114,114,0,0,0-15.6,1.43,115.82,115.82,0,0,0-15.26,3.57c-1.92.59-3.47,1.1-4.53,1.47a10.31,10.31,0,0,1-1.67.51,12.33,12.33,0,0,1,1.6-.7c1-.43,2.57-1,4.48-1.63a99.42,99.42,0,0,1,31-5c2,0,3.64.05,4.76.12A11.42,11.42,0,0,1,287.07,393.35Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.64,420.66a2.44,2.44,0,0,0-.78-1l-4.74-4.22-2.74,8.18a5.62,5.62,0,0,0,4.1,1.09,5.54,5.54,0,0,0,3.66-2.14A2.09,2.09,0,0,0,184.64,420.66Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.39,378.07l56.46,52.46,5.33,2.52,2.95,1.51L188.76,432,186,426.87l-57.16-52.5a2.51,2.51,0,0,0-3.42,0h0A2.52,2.52,0,0,0,125.39,378.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44,407.56l4.43.79s22.93-8.47,26.21-8.89c2.53-.33,14.6,2.5,19.94,3.81a4.68,4.68,0,0,1,3.64,4.68s0,.07,0,.1a4.66,4.66,0,0,1-3,4h0s4.5,1.4,2.47,6.16c-1.51,3.53-6.27,3-6.27,3l-7.93.16s2,.6,5.07,1.32a14.82,14.82,0,0,1,4.15,1.35s4.79,4.61.16,6.53a9.8,9.8,0,0,1-4.84.85s1.39,5-2.32,5.8-28.17-1-28.17-1a15.43,15.43,0,0,0-5-1.2l-6.9-.48Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.32,412.05a47.51,47.51,0,0,1-6.3-.36,46.42,46.42,0,0,1-6.25-.79,48.49,48.49,0,0,1,6.29.37A49.61,49.61,0,0,1,177.32,412.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.56,434.56c0,.05-.36-.08-.75-.48a3.15,3.15,0,0,1-.84-2,3.09,3.09,0,0,1,.69-2.06c.36-.43.69-.58.71-.54s-.2.28-.47.71a3.37,3.37,0,0,0-.51,1.87,3.43,3.43,0,0,0,.65,1.83C152.33,434.3,152.6,434.51,152.56,434.56Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19,426.26c0,.05-.43,0-1-.35a3,3,0,0,1-.5-4.53c.46-.48.86-.6.88-.55s-.3.26-.65.74a3,3,0,0,0,.45,4.1C151.85,426.07,152.21,426.2,152.19,426.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,416.6s-.43-.2-.83-.8a3.77,3.77,0,0,1,.89-5.08c.58-.44,1-.52,1-.47s-.37.24-.86.69a4.1,4.1,0,0,0-1.23,2.21,4,4,0,0,0,.41,2.5C151.79,416.24,152.1,416.55,152.05,416.6Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,404.19s-.22-.1-.37-.42a2,2,0,0,1-.08-1.35,2,2,0,0,1,.77-1.11c.3-.2.53-.21.54-.16s-.67.48-.91,1.38A4.09,4.09,0,0,0,155,404.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.59,421.19a14,14,0,0,1-3.42.15,14.13,14.13,0,0,1-3.41-.27,14,14,0,0,1,3.42-.15A14.85,14.85,0,0,1,166.59,421.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,431.4a46.36,46.36,0,0,1-6.19-1.1,45.2,45.2,0,0,1-6.1-1.52,49,49,0,0,1,6.19,1.11A47,47,0,0,1,170.3,431.4Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,435l.33,0,1,.12a15.38,15.38,0,0,1,3.73,1l0,0c3.21.21,8,.52,13.94.81,3,.14,6.29.29,9.84.31.89,0,1.8,0,2.71-.06a5.31,5.31,0,0,0,2.6-.57,3.07,3.07,0,0,0,1.35-2.26,7.49,7.49,0,0,0-.18-2.86l-.08-.33.34,0a8.86,8.86,0,0,0,3-.28,7.41,7.41,0,0,0,2.82-1.25,2.27,2.27,0,0,0,.5-2.75,8.34,8.34,0,0,0-1.85-2.7l0,0a21.1,21.1,0,0,0-4.39-1.4l-4.77-1.24-1.79-.47,1.86,0,7.94-.16h0a7.74,7.74,0,0,0,3.9-.66,4.82,4.82,0,0,0,2.59-4.23,3.88,3.88,0,0,0-2.8-3.75l-.66-.23.64-.25a4.47,4.47,0,0,0,2.79-3.73,4.35,4.35,0,0,0-2.1-4,7.29,7.29,0,0,0-2.26-.78l-2.36-.57L169,401.64c-3-.67-6-1.29-8.8-1.73-.7-.1-1.4-.2-2.09-.24a5.56,5.56,0,0,0-1,0c-.33.05-.66.12-1,.2-1.31.33-2.58.74-3.81,1.13-9.82,3.21-17.28,6-21.45,7.43h0l-3.32-.63-.83-.17-.27-.07a1,1,0,0,1,.28,0l.83.12,3.34.55h0c4.14-1.55,11.57-4.38,21.39-7.66,1.23-.39,2.5-.8,3.83-1.15.34-.09.69-.16,1-.22a6.49,6.49,0,0,1,1.08,0c.71,0,1.41.14,2.13.24,2.84.42,5.78,1,8.83,1.7l4.64,1.06,2.37.56a7.41,7.41,0,0,1,2.4.84,4.84,4.84,0,0,1,2.35,4.48,4.94,4.94,0,0,1-3.1,4.17l0-.48a5.18,5.18,0,0,1,2.29,1.58,3.87,3.87,0,0,1,.87,2.68,6.19,6.19,0,0,1-.78,2.72,4.74,4.74,0,0,1-2.1,2,8.25,8.25,0,0,1-4.19.7h0l-7.94.15.07-.5,4.73,1.24a20.43,20.43,0,0,1,4.56,1.48h0a9,9,0,0,1,2,2.88,3.28,3.28,0,0,1,.23,1.76,2.65,2.65,0,0,1-.29.86,3.15,3.15,0,0,1-.58.67,7.76,7.76,0,0,1-3,1.35,9.22,9.22,0,0,1-3.18.27l.26-.29a8.12,8.12,0,0,1,.17,3.06,3.52,3.52,0,0,1-1.55,2.56,5.85,5.85,0,0,1-2.82.63c-.93.05-1.84,0-2.73,0-3.57,0-6.86-.21-9.85-.37-6-.34-10.74-.7-14-1h0a16,16,0,0,0-3.66-1l-1-.17Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,434.57s-80.12,1.94-87.18-2-15.21-15.48-8.92-30.87,17.4-31.78,17.4-31.78l14.79,9.32,20.11,12.67L82,401.33l51.91,7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,401.33c0,.08-1.46-.53-3.82-1.3a75.7,75.7,0,0,0-9.4-2.37,85.38,85.38,0,0,0-9.63-1.25c-2.48-.17-4-.18-4-.26a4.42,4.42,0,0,1,1.09-.11c.69,0,1.71,0,3,0a64.91,64.91,0,0,1,9.7,1.1,58.32,58.32,0,0,1,9.43,2.54,26.61,26.61,0,0,1,2.74,1.13A4.94,4.94,0,0,1,82,401.33Z",
    style: {
      fill: "#ff9a6c"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherStudent);
export default __webpack_public_path__ + "static/media/teacher-student.4141daa3d57f11354c49838e148e2132.svg";
export { ForwardRef as ReactComponent };